<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span v-if="$route.name === 'memberNew'" class="title">회원관리</span>
            <span v-if="$route.name === 'CourseAccount'" class="title">수업 및 정산</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>

        <div class="com-table-top">
            <span v-if="!contractId" class="title">이용권 결제등록</span>
            <span v-else class="title">{{ returnYn ? '이용권 결제환불' : '이용권 결제수정' }}</span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div class="com-table-wrap">
                <span class="top-title"><span class="title">이용권 기본정보</span></span>
                <div class="com-card-input half-type">
                    <div class="left-box pr-16">
                        <div class="line">
                            <span class="tit">
                                센터
                                <span class="imp">*</span>
                            </span>
                            <div v-if="!contractId" class="input-cnt">
                                <select-form
                                    :select-data="[...chainCenterType]"
                                    :select-value="[...chainCenterTypeValue]"
                                    :selected-value="chainCenter"
                                    @update:set="(val) => (chainCenter = val)"
                                ></select-form>
                            </div>
                            <div v-else class="input-cnt">
                                <input :value="getCenterName()" class="w220" readonly type="text" />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                회원명
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <input v-model="editField.name" class="w220" readonly type="text" />
                                <button :disabled="customerId != ''" class="com-btn" @click="onClickSearchCustomer">
                                    검색
                                </button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                이용권
                                <span class="imp">*</span>
                            </span>
                            <div v-if="!contractId" class="d-flex align-items-center gap-2 mt-2.5">
                                <!-- 이용권 신규 등록시 -->
                                <select-form
                                    :select-data="['이용권 구분', ...Object.values(TICKET_TYPES)]"
                                    :select-value="['', ...Object.keys(TICKET_TYPES)]"
                                    class="w200"
                                    @update:set="handleProductTypeSelect"
                                />
                                <input v-model="searchProdKeyword" class="flex-1" type="text" />
                                <button :disabled="!searchProdKeyword" class="com-btn m-0" @click="onClickSearchProd">
                                    검색
                                </button>
                                <button class="com-search-reset m-0" @click="onResetSearch"></button>
                                <!-- <select-form-search
                  :select-data="['이용권 선택', ...centerProdTypeList]"
                  :select-value="['', ...centerProdTypeValueList]"
                  :selected-value="selectedProd"
                  class='w300'
                  style='margin-bottom:10px;white-space: pre-line;'
                  @update:set='onClickProduct'
                  :key='selectedProdType'
                /> -->
                            </div>
                            <div v-else-if="contractId && prodIsT === true" class="input-cnt">
                                <!-- 이용권 수정시 이용권명-->
                                <input
                                    :value="
                                        getTicketTypeString(
                                            addedProdListInfo.centerContractProducts[0].centerProduct.ticketType
                                        ) +
                                        ' ' +
                                        addedProdListInfo.centerContractProducts[0].centerProduct.name +
                                        ' ' +
                                        getLessonCntString(
                                            addedProdListInfo.centerContractProducts[0].centerProduct.lessonCountType,
                                            addedProdListInfo.centerContractProducts[0].centerProduct.lessonCount
                                        )
                                    "
                                    class="w400"
                                    readonly
                                    type="text"
                                />
                            </div>
                            <div v-else-if="contractId && prodIsP === true" class="input-cnt">
                                <!-- 패키지 수정시 이용권명-->
                                <input
                                    :value="'[패키지]' + ' ' + addedProdListInfo.centerContractProducts[0].productName"
                                    class="w400"
                                    readonly
                                    type="text"
                                />
                            </div>

                            <div v-if="!contractId" class="mt-4">
                                <table class="com-table">
                                    <colgroup>
                                        <col style="width: 80px" />
                                        <col />
                                        <col style="width: 120px" />
                                        <col style="width: 120px" />
                                    </colgroup>
                                    <thead>
                                        <tr>
                                            <th>구분</th>
                                            <th>이용권 명</th>
                                            <th>횟수</th>
                                            <th>유효기간</th>
                                        </tr>
                                    </thead>
                                </table>
                                <perfect-scrollbar style="max-height: 240px">
                                    <table class="com-table">
                                        <colgroup>
                                            <col style="width: 80px" />
                                            <col />
                                            <col style="width: 120px" />
                                            <col style="width: 120px" />
                                        </colgroup>
                                        <tbody>
                                            <tr
                                                v-for="(t, index) in centerProdTypeValueList"
                                                :key="index"
                                                class="pointer select-none"
                                                :class="
                                                    selectedProd && selectedProd.centerProductId === t.centerProductId
                                                        ? 'selected'
                                                        : ''
                                                "
                                                @click="onClickProduct(t)"
                                            >
                                                <td>{{ t.type }}</td>
                                                <td>{{ t.name }}</td>
                                                <td>{{ t.cntTxt }}</td>
                                                <td>{{ t.periodTxt }}</td>
                                            </tr>
                                            <tr v-if="centerProdTypeValueList.length === 0">
                                                <td colspan="100">이용권이 없습니다.</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </perfect-scrollbar>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                입력자
                                <span class="imp">*</span>
                            </span>
                            <div v-if="!contractId" class="input-cnt">
                                <select-form
                                    :select-data="[...centerStaffList]"
                                    :select-value="[...centerStaffValueList]"
                                    :selected-value="editField.regStaffId"
                                    class="w220"
                                    @update:set="(val) => (editField.regStaffId = val)"
                                ></select-form>
                            </div>
                            <div v-else-if="contractId" class="input-cnt">
                                <select-form
                                    :select-data="[...centerStaffList]"
                                    :select-value="[...centerStaffValueList]"
                                    :selected-value="addedProdListInfo.regStaffId"
                                    :disabled="returnYn"
                                    class="w220"
                                    @update:set="(val) => (addedProdListInfo.regStaffId = val)"
                                ></select-form>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                메모 ({{ memo.length | numberFormatFilter }} / {{ MEMO_MAX_LEN | numberFormatFilter }})
                            </span>
                            <div v-if="!contractId" class="input-cnt">
                                <!-- 이용권 신규 등록시 -->
                                <textarea
                                    v-model="editField.memo"
                                    class="com-textarea w400"
                                    :maxlength="MEMO_MAX_LEN"
                                ></textarea>
                            </div>
                            <div v-else-if="contractId" class="input-cnt">
                                <!-- 이용권 수정시 -->
                                <textarea
                                    v-model="addedProdListInfo.memo"
                                    :disabled="returnYn"
                                    class="com-textarea w400"
                                ></textarea>
                            </div>
                        </div>
                    </div>
                    <loading-spinner v-if="productIsLoading"></loading-spinner>
                    <div v-else class="right-box">
                        <!-- 이용권 정보 -->
                        <div v-for="(p, index) in addedProdList" :key="index" class="info-box">
                            <span class="title">이용권 기본정보</span>
                            <span class="sub-title">
                                <template v-if="!contractId">
                                    <!-- 이용권 신규 등록일 경우 -->
                                    <template v-if="prodIsT === true">
                                        <!-- 이용권인 경우 -->
                                        {{ getTicketTypeString(addedProdListInfo.ticketType) }}
                                        {{ addedProdListInfo.name }}
                                        {{ getLessonCntString(addedProdListInfo.lessonCountType, p.lessonCount) }}
                                    </template>
                                    <template v-if="prodIsP === true">
                                        <!-- 패키지인 경우 -->
                                        {{
                                            getTicketTypeString(
                                                addedProdListInfo.packageCenterProducts[index].ticketType
                                            )
                                        }}
                                        {{ addedProdListInfo.packageCenterProducts[index].name }}
                                        {{
                                            getLessonCntString(
                                                addedProdListInfo.packageCenterProducts[index].lessonCountType,
                                                addedProdListInfo.packageCenterProducts[index].lessonCount
                                            )
                                        }}
                                    </template>
                                </template>
                                <template v-if="contractId">
                                    <!-- 이용권 수정일 경우 -->
                                    <template v-if="prodIsT === true">
                                        <!-- 이용권인 경우 -->
                                        {{
                                            getTicketTypeString(
                                                addedProdListInfo.centerContractProducts[0].centerProduct.ticketType
                                            )
                                        }}
                                        {{ addedProdList[index].productName }}
                                        {{
                                            getLessonCntString(
                                                addedProdList[index].lessonCountType,
                                                addedProdList[index].lessonCount
                                            )
                                        }}
                                    </template>
                                    <template v-else-if="prodIsP === true">
                                        <!-- 패키지인 경우 -->
                                        {{ getTicketTypeString(p.centerProduct.ticketType) }}
                                        {{ p.centerProduct.name }}
                                        {{
                                            getLessonCntString(
                                                p.centerProduct.lessonCountType,
                                                p.centerProduct.lessonCount
                                            )
                                        }}
                                    </template>
                                </template>
                            </span>
                            <div class="line">
                                <!-- 이용권 정보 2개 이상 있을시 나오는 버튼 -->
                                <span v-if="contractId" class="">
                                    <button
                                        v-if="contractId && !returnYn && !addedProdListInfo.transmission_yn"
                                        class="com-btn blue"
                                        @click="openTransmissionPop()"
                                    >
                                        이용권 양도
                                    </button>
                                    <button
                                        v-if="!returnYn"
                                        class="com-btn red"
                                        @click="
                                            checkAllowedClick('LE', 4, () => {
                                                onClickExtendDetail(p, 1);
                                            })
                                        "
                                    >
                                        기간연장
                                    </button>
                                    <button
                                        class="com-btn"
                                        @click="
                                            checkAllowedClick('LE', 4, () => {
                                                onClickExtendDetail(p, 2);
                                            })
                                        "
                                    >
                                        연장내역
                                    </button>
                                    <button
                                        class="com-btn blue"
                                        @click="
                                            moveHistory(
                                                addedProdListInfo.centerContractProducts[0].centerProduct.ticketType,
                                                addedProdList[index].productName,
                                                editField.name
                                            )
                                        "
                                    >
                                        히스토리 내역
                                    </button>
                                </span>
                                <!-- //이용권 정보 2개 이상 있을시 나오는 버튼 -->
                            </div>
                            <div class="line">
                                <span class="tit">
                                    유효기간
                                    <span class="imp">*</span>
                                </span>
                                <div class="input-cnt">
                                    <div class="com-calendar-wrap">
                                        <template v-if="!contractId">
                                            <!-- 이용권 신규 등록일 경우 -->
                                            <single-calendar
                                                :id="p.centerProductId"
                                                :start-date="p.expireStartDt"
                                                @change="changeExpireDate"
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="p.expireEndDt"
                                                @update="(val) => (p.expireEndDt = val)"
                                            ></single-calendar>
                                        </template>
                                        <template v-if="contractId">
                                            <!-- 이용권 수정일 경우 -->
                                            <single-calendar
                                                :start-date="p.expireStartDt"
                                                :disabled="returnYn"
                                                @update="(val) => (p.expireStartDt = val)"
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="p.expireEndDt"
                                                :disabled="returnYn"
                                                @update="(val) => (p.expireEndDt = val)"
                                            ></single-calendar>
                                        </template>
                                    </div>
                                </div>
                            </div>
                            <div class="line"  v-if="isAllowed('SA', 6)">
                                <span class="tit">정상가</span>
                                <div class="input-cnt">
                                    <input
                                        class="w220"
                                        readonly
                                        type="text"
                                        v-bind:value="getNumberFormat(p.productOrgPrice)"
                                    />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                            <div class="line"  v-if="isAllowed('SA', 6)">
                                <span class="tit">
                                    실제구매가
                                    <span class="imp">*</span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <span class="tit">실제구매가</span>
                                            <p class="txt">
                                                정상가와 실제 구매가의 가격이 다를 경우 변경할 수 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </span>
                                <div class="input-cnt">
                                    <input
                                        class="w220"
                                        maxlength="12"
                                        type="text"
                                        v-bind:value="getNumberFormat(p.productBuyPrice)"
                                        :disabled="returnYn"
                                        @keypress="isNumber($event)"
                                        v-on:keyup="onKeyupProdBuyPrice($event, index)"
                                    />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                            <div class="line">
                                <span class="tit">
                                    횟수
                                    <span class="imp">*</span>
                                    &nbsp;
                                    <span v-if="checkAllowedCount(p.lessonCount, p.lessonCountType)" class="red">
                                        {{ countMessage }}
                                    </span>
                                </span>
                                <div class="input-cnt">
                                    <span class="txt">{{ getLessonCntType(p.lessonCountType) }}</span>
                                    <!-- <span class="txt" v-if="prodIsT === true">{{ getLessonCntType(p.lessonCountType) }}</span> 이용권인 경우 -->
                                    <!-- <span class="txt" v-else-if="!contractId && prodIsP === true">{{ getLessonCntType(p.lessonCountType) }}</span> 패키지 등록인 경우 -->
                                    <!-- <span class="txt" v-else-if="contractId && prodIsP === true">{{ getLessonCntType(p.lessonCountType) }}</span> 패키지 수정인 경우 -->
                                    <span v-if="!isInfinity(index, p)">
                                        <input
                                            v-model="p.lessonCount"
                                            :disabled="p.lessonCountType === 'W' || returnYn"
                                            class="w70"
                                            maxlength="3"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="txt">회</span>
                                    </span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <span class="tit">횟수</span>
                                            <p class="txt">
                                                총 횟수 변경 시, 1회당 단가(실제 구매가/횟수)가 변경되며 %급여 정산에
                                                영향을 미칠 수 있습니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <span class="tit">수업시간</span>
                                <div class="input-cnt">
                                    <template v-if="!contractId">
                                        <!-- 이용권 신규 등록일 경우 -->
                                        <template v-if="prodIsT === true">
                                            <!-- 이용권인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="[0, 30, 60, 90, 120]"
                                                :selected-value="
                                                    addedProdListInfo.lessonTime === null
                                                        ? 0
                                                        : addedProdListInfo.lessonTime
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                        <template v-else-if="prodIsP === true">
                                            <!-- 패키지인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="[0, 30, 60, 90, 120]"
                                                :selected-value="
                                                    addedProdListInfo.packageCenterProducts[index].lessonTime === null
                                                        ? 0
                                                        : addedProdListInfo.packageCenterProducts[index].lessonTime
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                    </template>
                                    <template v-if="contractId">
                                        <!-- 이용권 수정일 경우 -->
                                        <template v-if="prodIsT === true">
                                            <!-- 이용권인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="[0, 30, 60, 90, 120]"
                                                :selected-value="
                                                    p.centerProduct.lessonTime === null
                                                        ? 0
                                                        : addedProdListInfo.centerContractProducts[0].centerProduct
                                                              .lessonTime
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                        <template v-else-if="prodIsP === true">
                                            <!-- 패키지인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="[0, 30, 60, 90, 120]"
                                                :selected-value="
                                                    p.centerProduct.lessonTime === null ? 0 : p.centerProduct.lessonTime
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                    </template>
                                    <span class="txt">시간</span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <span class="tit">시간</span>
                                            <p class="txt">
                                                회원과 1회당 진행하는 이용권시간입니다. 설정한 시간이 스케줄표에
                                                적용됩니다.
                                            </p>
                                        </div>
                                    </div>
                                    <template v-if="!contractId">
                                        <!-- 이용권 신규 등록일 경우 -->
                                        <template v-if="prodIsT === true">
                                            <!-- 이용권인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="['0', '0.5', '1.0', '1.5', '2.0']"
                                                :selected-value="
                                                    addedProdListInfo.lessonPerLessonCount === null
                                                        ? '0'
                                                        : addedProdListInfo.lessonPerLessonCount
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                        <template v-else-if="prodIsP === true">
                                            <!-- 패키지인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5회', '1', '1.5', '2']"
                                                :select-value="['0', '0.5', '1.0', '1.5', '2.0']"
                                                :selected-value="
                                                    addedProdListInfo.packageCenterProducts[index]
                                                        .lessonPerLessonCount === null
                                                        ? '0'
                                                        : addedProdListInfo.packageCenterProducts[index]
                                                              .lessonPerLessonCount
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                    </template>
                                    <template v-if="contractId">
                                        <!-- 이용권 수정일 경우 -->
                                        <template v-if="prodIsT === true">
                                            <!-- 이용권인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="['0', '0.5', '1.0', '1.5', '2.0']"
                                                :selected-value="
                                                    p.centerProduct.lessonPerLessonCount === null
                                                        ? '0'
                                                        : addedProdListInfo.centerContractProducts[0].centerProduct
                                                              .lessonPerLessonCount
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                        <template v-else-if="prodIsP === true">
                                            <!-- 패키지인 경우 -->
                                            <select-form
                                                :select-data="['0', '0.5', '1', '1.5', '2']"
                                                :select-value="['0', '0.5', '1.0', '1.5', '2.0']"
                                                :selected-value="
                                                    p.centerProduct.lessonPerLessonCount === null
                                                        ? '0'
                                                        : p.centerProduct.lessonPerLessonCount
                                                "
                                                class="w70"
                                                disabled
                                            ></select-form>
                                        </template>
                                    </template>
                                    <span class="txt">회</span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <span class="tit">회</span>
                                            <p class="txt">
                                                직원의 월말정산 시, 한 달 총 수업횟수를 합산할 때, 수업시간에 따라
                                                몇회로 인정할 지 설정합니다.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <span class="tit">
                                    매출직원
                                    <span class="imp">*</span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <span class="tit">매출직원</span>
                                            <p class="txt">
                                                월별정산에서 신규매출/재등록매출/매출인센티브를 계산할 때, 최초 선택된
                                                직원에게 적용됩니다.
                                            </p>
                                        </div>
                                    </div>
                                </span>
                                <div class="input-cnt">
                                    <select-form
                                        :select-data="['선택안함', ...centerStaffList]"
                                        :select-value="[null, ...centerStaffValueList]"
                                        :selected-value="p.saleStaffId"
                                        :disabled="returnYn"
                                        class="w220"
                                        @update:set="(val) => (p.saleStaffId = val)"
                                    ></select-form>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-s1-1-${index}`"
                                            v-model="p.saleStaffContractType"
                                            :name="`radio-s1-${index}`"
                                            :disabled="returnYn"
                                            type="radio"
                                            value="N"
                                        />
                                        <label :for="`radio-s1-1-${index}`">신규</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-s1-2-${index}`"
                                            v-model="p.saleStaffContractType"
                                            :name="`radio-s1-${index}`"
                                            :disabled="returnYn"
                                            type="radio"
                                            value="R"
                                        />
                                        <label :for="`radio-s1-2-${index}`">재등록</label>
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <span class="tit">
                                    담당강사
                                    <span class="imp">*</span>
                                    <div class="com-tooltip">
                                        <button class="icon"></button>
                                        <div class="detail">
                                            <span class="tit">담당강사</span>
                                            <p class="txt">
                                                월별정산에서 신규/재등록 이용권 수를 계산할 때 최초 선택된 담당강사에게
                                                적용됩니다.
                                            </p>
                                        </div>
                                    </div>
                                </span>
                                <div class="input-cnt">
                                    <select-form
                                        :select-data="['선택안함', ...centerStaffList]"
                                        :select-value="[null, ...centerStaffValueList]"
                                        :selected-value="p.lessonStaffId"
                                        :disabled="returnYn"
                                        class="w220"
                                        @update:set="(val) => (p.lessonStaffId = val)"
                                    ></select-form>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-s2-1-${index}`"
                                            v-model="p.lessStaffContractType"
                                            :name="`radio-s2-${index}`"
                                            :disabled="returnYn"
                                            type="radio"
                                            value="N"
                                        />
                                        <label :for="`radio-s2-1-${index}`">신규</label>
                                    </div>
                                    <div class="com-radio">
                                        <input
                                            :id="`radio-s2-2-${index}`"
                                            v-model="p.lessStaffContractType"
                                            :name="`radio-s2-${index}`"
                                            :disabled="returnYn"
                                            type="radio"
                                            value="R"
                                        />
                                        <label :for="`radio-s2-2-${index}`">재등록</label>
                                    </div>
                                </div>
                                <div class="sub-line">
                                    <div class="com-check">
                                        <input
                                            :id="`check-s1-1-${index}`"
                                            v-model="p.lessonResverStaffYn"
                                            :disabled="returnYn"
                                            name="check-1"
                                            type="checkbox"
                                        />
                                        <label :for="`check-s1-1-${index}`">
                                            회원APP에서 지정된 강사에게만 예약 가능
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <!-- 이용권 등록인경우 -->
                            <template v-if="!contractId">
                                <div
                                    v-if="addedProdListInfo.ticketType == 'P' || addedProdListInfo.ticketType == 'O'"
                                    class="line"
                                >
                                    <span class="tit">
                                        1회 당 정산금액
                                        <small>(필요할 경우에만 입력)</small>
                                    </span>
                                    <div class="input-cnt">
                                        <input
                                            class="w220"
                                            maxlength="12"
                                            placeholder="필요 시 입력"
                                            type="text"
                                            v-bind:value="
                                                p.turnBillPrice !== null ? getNumberFormat(p.turnBillPrice) : ''
                                            "
                                            @input="onKeyupTurnBillPrice($event, index)"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="txt">원</span>
                                        <div class="com-tooltip">
                                            <button class="icon"></button>
                                            <div class="detail">
                                                <span class="tit">1회 당 정산금액</span>
                                                <p class="txt">
                                                    해당 이용권만 별도의 정산금액 적용을 원할 경우 입력합니다. 강사에게
                                                    설정된 기본 급여설정 보다 우선 적용됩니다.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                            <!-- 이용권 수정인경우 -->
                            <template v-if="contractId">
                                <div
                                    v-if="
                                        isAllowed('LE', 5) &&
                                        (addedProdListInfo.centerContractProducts[0].centerProduct.ticketType == 'P' ||
                                            addedProdListInfo.centerContractProducts[0].centerProduct.ticketType == 'O')
                                    "
                                    class="line"
                                >
                                    <span class="tit">
                                        1회 당 정산금액
                                        <small>(필요할 경우에만 입력)</small>
                                    </span>
                                    <div class="input-cnt">
                                        <input
                                            class="w220"
                                            maxlength="12"
                                            placeholder="필요 시 입력"
                                            type="text"
                                            v-bind:value="
                                                p.turnBillPrice !== null ? getNumberFormat(p.turnBillPrice) : ''
                                            "
                                            @input="onKeyupTurnBillPrice($event, index)"
                                            @keypress="isNumber($event)"
                                        />
                                        <span class="txt">원</span>
                                        <div class="com-tooltip">
                                            <button class="icon"></button>
                                            <div class="detail">
                                                <span class="tit">1회 당 정산금액</span>
                                                <p class="txt">
                                                    해당 이용권만 별도의 정산금액 적용을 원할 경우 입력합니다. 강사에게
                                                    설정된 기본 급여설정 보다 우선 적용됩니다.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>

                <span class="top-title"><span class="title">이용권 결제정보</span></span>

                <div class="com-card-form"  v-if="isAllowed('SA', 6)">
                    <div class="top-area">
                        <div class="line">
                            <span class="txt w120">결제 예정 금액 :</span>
                            <span class="input-box">
                                <input
                                    :value="totalBuyPrice"
                                    class="w220"
                                    disabled
                                    style="text-align: right; padding-right: 10px"
                                    type="text"
                                />
                                원
                            </span>
                        </div>
                        <!--
            고객 요구에 의해서 삭제
            <div class="line">
                <span class="txt w120">이용권 횟수 :</span>
                <span class="input-box"><input type="text" class="w220" disabled :value="totalLessonCount" style="text-align: right; padding-right:10px;"> 회</span>
            </div>
            -->
                    </div>
                    <div class="middle-area">
                        <!-- 결제 정보 -->
                        <template v-for="(b, index) in editField.bills">
                            <!-- 등록일 때 -->
                            <template v-if="!contractId">
                                <payment-info
                                    v-if="!contractId"
                                    :key="`CP${index}`"
                                    :bill-data="b"
                                    :index="index"
                                    :is-show-btn-delete-payment="b.isShowBtnDeletePayment"
                                    :is-use-mileage="true"
                                    :is-use-receipt="true"
                                    :mileage="customerInfo.mileage"
                                    :mileageInfo="mileageInfo"
                                    :max="addedProdList"
                                    :mode="''"
                                    :taxTelNo="customerInfo.taxTelNo"
                                    :totalBuyPrice="totalBuyPrice"
                                    :billCount="billCount"
                                    :fitpayMode="centerInfo.fpMode"
                                    v-on:on-change="onChangePaymentFields"
                                    v-on:on-click-delete="onClickDeletePaymentFields"
                                ></payment-info>
                                <div :key="`CB${index}`" class="info">
                                    <!-- <div style="text-align: right" v-if="!returnYn && index !== 0">
                      <button class="com-btn red" @click="checkAllowedClick('LE', 2, editField.bills.pop)">삭제</button>
                  </div> -->
                                </div>
                            </template>
                            <!-- 수정일 때 -->
                            <template v-if="contractId && b.hasOwnProperty('mode')">
                                <payment-info
                                    :key="`MP${index}`"
                                    :bill-data="b"
                                    :index="index"
                                    :is-use-mileage="true"
                                    :is-use-receipt="true"
                                    :mileage="customerInfo.mileage"
                                    :mileageInfo="mileageInfo"
                                    :mode="b.mode"
                                    :max="addedProdList"
                                    :billCount="billCount"
                                    :fitpayMode="centerInfo.fpMode"
                                    v-on:on-change="onChangePaymentFields"
                                    v-on:on-click-delete="onClickDeletePaymentFields"
                                ></payment-info>
                                <div v-if="!returnYn" :key="`MB${index}`" class="info">
                                    <div style="text-align: right">
                                        <button
                                            v-if="b.mode === 'read'"
                                            class="com-btn"
                                            style="margin-right: 15px"
                                            @click="
                                                checkAllowedClick('LE', 2, () => {
                                                    onClickModifyBills(
                                                        b.centerCustomerId,
                                                        b.centerContractId,
                                                        b.billSeq,
                                                        index
                                                    );
                                                })
                                            "
                                        >
                                            수정
                                        </button>
                                        <button
                                            v-else-if="b.mode === 'modify'"
                                            class="com-btn"
                                            style="margin-right: 15px"
                                            @click="
                                                checkAllowedClick('LE', 2, () => {
                                                    onClickSaveBills(
                                                        b.centerCustomerId,
                                                        b.centerContractId,
                                                        b.billSeq,
                                                        index
                                                    );
                                                })
                                            "
                                        >
                                            저장
                                        </button>
                                        <button
                                            v-if="b.mode === 'modify'"
                                            class="com-btn"
                                            style="margin-right: 15px"
                                            @click="b.mode = 'read'"
                                        >
                                            취소
                                        </button>
                                        <button
                                            class="com-btn red"
                                            @click="
                                                checkAllowedClick('LE', 2, () => {
                                                    onClickDeleteBills(
                                                        b.centerCustomerId,
                                                        b.centerContractId,
                                                        b.billSeq,
                                                        index
                                                    );
                                                })
                                            "
                                        >
                                            삭제
                                        </button>
                                    </div>
                                </div>
                            </template>

                            <!-- 수정인데 결제정보추가할 경우 -->
                            <template v-if="contractId && !b.hasOwnProperty('mode')">
                                <payment-info
                                    :key="`MAP${index}`"
                                    :bill-data="b"
                                    :index="index"
                                    :is-show-btn-delete-payment="b.isShowBtnDeletePayment"
                                    :is-use-mileage="true"
                                    :is-use-receipt="true"
                                    :mileage="customerInfo.mileage"
                                    :mileageInfo="mileageInfo"
                                    :max="addedProdList"
                                    :mode="''"
                                    :billCount="billCount"
                                    :fitpayMode="centerInfo.fpMode"
                                    v-on:on-change="onChangePaymentFields"
                                    v-on:on-click-delete="onClickDeletePaymentFields"
                                ></payment-info>
                                <div :key="`MAB${index}`" class="info">
                                    <!-- <div style="text-align: right" v-if="!returnYn">
                      <button class="com-btn red" @click="checkAllowedClick('LE', 2, editField.bills.pop)">삭제</button>
                  </div> -->
                                </div>
                            </template>
                        </template>

                        <div v-if="!returnYn && moreBillable" class="com-send-btn">
                            <!-- <div class="com-send-btn" v-if="!returnYn"> -->
                            <button class="com-btn blue" @click="checkAllowedClick('LE', 2, onClickAddPayment)">
                                결제정보추가
                            </button>
                        </div>

                        <!-- 환불 정보 -->
                        <div
                            v-if="addedProdList.length > 0 && (addedProdList[0].returnStaffId || '')"
                            class="payment-box"
                        >
                            <span class="title">환불정보</span>
                            <ul class="info-list">
                                <li>
                                    <span class="tit">환불직원 :</span>
                                    <div class="info">
                                        <select-form
                                            :select-data="[...centerStaffList]"
                                            :disabled="true"
                                            :select-value="[...centerStaffValueList]"
                                            :selected-value="addedProdList[0].returnStaffId"
                                            class="w220"
                                            @update:set="(val) => (addedProdList[0].returnStaffId = val)"
                                        ></select-form>
                                    </div>
                                </li>
                                <li>
                                    <span class="tit">환불신청 :</span>
                                    <div class="info">
                                        <single-calendar
                                            :date="addedProdList[0].returnApplyAt | timestampFilter"
                                            :disabled="true"
                                            @update="(val) => (addedProdList[0].returnApplyAt = val)"
                                            class="w220"
                                        ></single-calendar>
                                        <span v-if="addedProdList[0].returnExecAt !== null" class="txt red">
                                            ({{ addedProdList[0].returnExecAt | timestampFilter }} 환불완료)
                                        </span>
                                    </div>
                                </li>
                                <li>
                                    <span class="tit">사용금액 :</span>
                                    <div class="info">
                                        <input
                                            class="w220"
                                            maxlength="12"
                                            type="text"
                                            :disabled="true"
                                            v-bind:value="
                                                addedProdList[0].returnUsePrice === null
                                                    ? ''
                                                    : getNumberFormat(addedProdList[0].returnUsePrice)
                                            "
                                            @keypress="isNumber($event)"
                                            v-on:input="onKeyupReturnUsePrice($event, 0)"
                                        />
                                        <span class="txt">원</span>
                                    </div>
                                </li>
                                <li>
                                    <span class="tit">환불금액 :</span>
                                    <div class="info">
                                        <input
                                            class="w220"
                                            maxlength="12"
                                            type="text"
                                            :disabled="true"
                                            v-bind:value="
                                                addedProdList[0].returnPrice === null
                                                    ? ''
                                                    : getNumberFormat(addedProdList[0].returnPrice)
                                            "
                                            @keypress="isNumber($event)"
                                            v-on:input="onKeyupReturnPrice($event, 0)"
                                        />
                                        <span class="txt">원</span>
                                    </div>
                                </li>
                                <li>
                                    <span class="tit">마일리지 :</span>
                                    <div class="info">
                                        <!--                                        <input class='w220'-->
                                        <!--                                               type='text'-->
                                        <!--                                               v-bind:value='addedProdList[0].returnMileagePrice !== null ? getNumberFormat(addedProdList[0].returnMileagePrice) : 0'>-->
                                        <input
                                            class="w220"
                                            type="text"
                                            v-model="addedProdList[0].returnMileagePrice"
                                            @keypress="isNumber($event)"
                                            :disabled="true"
                                            v-on:input="onKeyupReturnMileagePrice($event, true)"
                                        />
                                        <span class="txt">원 차감예정</span>
                                    </div>
                                </li>
                                <li>
                                    <span class="tit">환불수단 :</span>
                                    <div class="sub">
                                        <div class="com-radio">
                                            <input
                                                id="radio1"
                                                :disabled="true"
                                                v-model="addedProdList[0].returnPayType"
                                                name="radio1"
                                                type="radio"
                                                value="L"
                                            />
                                            <label for="radio1">현금</label>
                                        </div>
                                        <div class="com-radio" style="margin-left: 15px">
                                            <input
                                                id="radio2"
                                                :disabled="true"
                                                v-model="addedProdList[0].returnPayType"
                                                name="radio2"
                                                type="radio"
                                                value="B"
                                            />
                                            <label for="radio2">계좌이체</label>
                                        </div>
                                        <div class="com-radio" style="margin-left: 15px">
                                            <input
                                                id="radio3"
                                                :disabled="true"
                                                v-model="addedProdList[0].returnPayType"
                                                name="radio3"
                                                type="radio"
                                                value="C"
                                            />
                                            <label for="radio3">카드취소</label>
                                        </div>
                                    </div>
                                </li>
                                <li>
                                    <span class="tit">환불사유 :</span>
                                    <div class="info">
                                        <textarea
                                            class="with-btn"
                                            v-bind:value="addedProdList[0].returnMemo"
                                            :disabled="true"
                                        ></textarea>
                                        <div v-if="!returnYn" class="right-btn">
                                            <!--<button class="com-btn" v-if="!returnModify" @click="returnModify = true">수정</button>-->
                                            <!--<button class="com-btn" v-else-if="returnModify" @click="returnModify = false">저장</button>-->
                                            <button class="com-btn red" @click="onClickCancleReturn">삭제</button>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div class="bottom-total">
                            <span class="tit">결제 후 미수금액 :</span>
                            <span class="num">{{ totalDebtPrice }} 원</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="com-btn-area">
                <div v-if="contractId" class="left-box">
                    <a class="com-btn" href="#" @click="onClickCancleBtn">목록</a>
                </div>
                <div v-if="contractId" class="right-box">
                    <a class="com-btn red" href="#" @click="checkAllowedClick('LE', 3, onClickDeleteBtn)">삭제</a>
                </div>
            </div>
            <div class="bottom-btn">
                <button class="com-btn" @click="onClickCancleBtn">취소</button>

                <button v-if="isAllowed('LE', 1) && !contractId" class="com-btn blue" @click="onClickRegistContract">
                    등록
                </button>

                <button
                    v-else-if="contractId && !returnYn"
                    class="com-btn blue"
                    @click="checkAllowedClick('LE', 2, onClickModifyContract)"
                >
                    수정
                </button>
                <button
                    v-if="contractId && !returnYn"
                    class="com-btn red"
                    @click="checkAllowedClick('LE', 2, onPopupRefund)"
                >
                    환불신청
                </button>
            </div>

            <!-- 환불 신청 레이어 팝업 -->
            <div v-show="refundPop" class="layer-pop square">
                <div class="view-content w1425">
                    <button class="close" @click="refundPop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <loading-spinner v-if="returnIsLoading"></loading-spinner>
                        <div v-else class="input-info-box">
                            <span class="title">환불 신청</span>
                            <!-- 이용권 정보 -->
                            <div v-for="(p, index) in addedProdList" :key="index" class="use-info-cnt">
                                <span class="title">이용권 정보</span>
                                <div class="line">
                                    <div class="input-wrap">
                                        <span class="tit">이름</span>
                                        <input v-model="editField.name" class="w220" readonly type="text" />
                                    </div>
                                    <div class="input-wrap">
                                        <span class="tit">총 결제금액</span>
                                        <input
                                            class="w440"
                                            readonly
                                            type="text"
                                            v-bind:value="getNumberFormat(p.productBuyPrice)"
                                        />
                                    </div>
                                </div>
                                <!-- 이용권일 경우 -->
                                <span v-if="contractId && prodIsT === true" class="title blue">
                                    {{
                                        getTicketTypeString(
                                            addedProdListInfo.centerContractProducts[0].centerProduct.ticketType
                                        ) +
                                        ' ' +
                                        addedProdListInfo.centerContractProducts[0].centerProduct.name
                                    }}
                                </span>
                                <!-- 패키지일 경우 -->
                                <span v-if="contractId && prodIsP === true" class="title blue">
                                    {{ getTicketTypeString(p.centerProduct.ticketType) }} {{ p.centerProduct.name }}
                                    {{
                                        getLessonCntString(p.centerProduct.lessonCountType, p.centerProduct.lessonCount)
                                    }}
                                </span>
                                <div class="line">
                                    <div class="input-wrap">
                                        <span class="tit">담당강사</span>
                                        <input
                                            :value="searchByLessStaffId(p.lessonStaffId)"
                                            class="w220"
                                            readonly
                                            type="text"
                                        />
                                    </div>
                                    <div class="input-wrap">
                                        <span class="tit">매출직원</span>
                                        <input
                                            :value="searchBySaleStaffId(p.saleStaffId)"
                                            class="w220"
                                            readonly
                                            type="text"
                                        />
                                    </div>
                                    <!--                                {{ t.cc_less_join_cnt + t.cc_less_absn_cnt }}</span>/{{ t.cc_less_cnt }} 회-->
                                    <div class="input-wrap">
                                        <span class="tit">사용횟수</span>
                                        <input
                                            :value="`${p.lessonJoinCount + p.lessonAbsentCount} / ${p.lessonCount} 회`"
                                            class="w220"
                                            readonly
                                            type="text"
                                        />
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="input-wrap">
                                        <span class="tit">유효기간</span>
                                        <div class="com-calendar-wrap">
                                            <single-calendar
                                                :disabled="true"
                                                :start-date="p.expireStartDt"
                                            ></single-calendar>
                                            <div class="com-dash"><span class="dash">~</span></div>
                                            <single-calendar
                                                :end-date="today"
                                                @update="(val) => (p.returnExpireEndDt = val)"
                                            ></single-calendar>
                                        </div>
                                        <span class="txt red">※ 환불 시 이용권의 종료일자를 선택하세요.</span>
                                    </div>
                                </div>
                                <div class="line">
                                    <div class="input-wrap">
                                        <span class="tit">
                                            사용금액
                                            <span class="imp">*</span>
                                            <div class="com-tooltip left">
                                                <button class="icon"></button>
                                                <div class="detail">
                                                    <span class="tit">사용금액</span>
                                                    <p class="txt">
                                                        회원이 사용하여 제외될 금액으로 위약금이 있다면 사용금액 안에
                                                        포함 해 주세요.
                                                    </p>
                                                </div>
                                            </div>
                                        </span>
                                        <input
                                            class="w220"
                                            maxlength="12"
                                            type="text"
                                            v-bind:value="
                                                p.returnUsePrice === null ? '' : getNumberFormat(p.returnUsePrice)
                                            "
                                            @keypress="isNumber($event)"
                                            v-on:input="onKeyupReturnUsePrice($event, index)"
                                        />
                                        <span class="input-txt">원</span>
                                    </div>
                                    <div class="input-wrap">
                                        <span class="tit">
                                            환불금액
                                            <span class="imp">*</span>
                                            <div class="com-tooltip">
                                                <button class="icon"></button>
                                                <div class="detail">
                                                    <span class="tit">환불금액</span>
                                                    <p class="txt">실제 회원에게 환불되는 금액입니다.</p>
                                                </div>
                                            </div>
                                        </span>
                                        <input
                                            class="w220"
                                            maxlength="12"
                                            type="text"
                                            v-bind:value="p.returnPrice === null ? '' : getNumberFormat(p.returnPrice)"
                                            @keypress="isNumber($event)"
                                            v-on:input="onKeyupReturnPrice($event, index)"
                                        />
                                        <span class="input-txt">원</span>
                                    </div>
                                </div>
                            </div>
                            <span class="bar-line"></span>
                            <span class="title">환불 정보</span>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">
                                        환불직원
                                        <span class="imp">*</span>
                                    </span>
                                    <select-form
                                        :select-data="[...centerStaffList]"
                                        :select-value="[...centerStaffValueList]"
                                        :selected-value="returnStaffId"
                                        class="w220"
                                        @update:set="(val) => (returnStaffId = val)"
                                    ></select-form>
                                </div>
                                <div class="input-wrap">
                                    <span class="tit">
                                        환불 신청일
                                        <span class="imp">*</span>
                                    </span>
                                    <single-calendar
                                        :date="today"
                                        class="w220"
                                        @update="(val) => (returnApplyAt = val)"
                                    ></single-calendar>
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">마일리지 차감</span>
                                    <input
                                        class="w220"
                                        type="text"
                                        v-model="returnMileagePrice"
                                        @keypress="isNumber($event)"
                                        v-on:input="onKeyupReturnMileagePrice($event)"
                                    />
                                    <span class="input-txt">원 차감됩니다.</span>
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap">
                                    <span class="tit">
                                        환불수단
                                        <span class="imp">*</span>
                                    </span>
                                    <div class="sub">
                                        <div class="com-radio">
                                            <input
                                                id="radio-acc-1-1"
                                                v-model="returnPayType"
                                                name="radio-acc-1-1"
                                                type="radio"
                                                value="L"
                                            />
                                            <label for="radio-acc-1-1">현금</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-acc-2-1"
                                                v-model="returnPayType"
                                                name="radio-acc-2-1"
                                                type="radio"
                                                value="B"
                                            />
                                            <label for="radio-acc-2-1">계좌이체</label>
                                        </div>
                                        <div class="com-radio">
                                            <input
                                                id="radio-acc-3-1"
                                                v-model="returnPayType"
                                                name="radio-acc-3-1"
                                                type="radio"
                                                value="C"
                                            />
                                            <label for="radio-acc-3-1">카드취소</label>
                                        </div>
                                    </div>
                                    <div v-if="returnPayType !== 'B'" class="sub">
                                        <input
                                            :value="totalReturnPrice === '0' ? '' : totalReturnPrice"
                                            class="w220"
                                            placeholder="환불합계 금액"
                                            readonly
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                    <div v-if="returnPayType === 'B'" class="sub">
                                        <input
                                            :value="totalReturnPrice === '0' ? '' : totalReturnPrice"
                                            class="w220"
                                            placeholder="환불합계 금액"
                                            readonly
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                        <input
                                            v-model="returnPayBank"
                                            class="w220"
                                            maxlength="10"
                                            placeholder="은행명 입력"
                                            type="text"
                                        />
                                        <input
                                            v-model="returnPayOwn"
                                            class="w220"
                                            maxlength="10"
                                            placeholder="예금주 입력"
                                            type="text"
                                        />
                                        <input
                                            v-model="returnPayAccount"
                                            class="w220"
                                            maxlength="20"
                                            placeholder="계좌번호 입력"
                                            type="text"
                                            @keypress="isNumber($event)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="input-wrap w100p">
                                    <span class="tit">환불사유 및 메모</span>
                                    <div class="sub">
                                        <textarea v-model="returnMemo" placeholder="내용을 입력해주세요."></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="com-notice-list">
                            <ul class="list">
                                <!-- <li>※ 유효기간은 환불신청일까지로 종료되며 예약 및 입장이 불가합니다.</li> -->
                                <li>
                                    ※ 최종 환불완료 처리는
                                    <span class="blue">매출 > 환불관리</span>
                                    에서 가능합니다.
                                </li>
                            </ul>
                        </div>

                        <div class="bottom-btn">
                            <button class="com-btn" @click="refundPop = false">취소</button>
                            <button class="com-btn blue" @click="onClickRegistReturn">등록</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 기간연장 및 연장 내역에 관한 팝업 -->
            <period-pop
                v-if="periodPop"
                v-bind="periodPopProps"
                @close="periodPop = false"
                @period-init="periodInit"
            ></period-pop>

            <!-- 이용권 양도 -->
            <div v-if="transmissionPop" class="layer-pop square">
                <div class="view-content w740" style="padding: 40px 35px 30px">
                    <button class="close" @click="transmissionPop = false"><span class="blind">팝업 닫기</span></button>
                    <div class="scroll-area com-scroll-y">
                        <div class="com-tab" style="margin: 0px">
                            <button @click="assign = !assign" :class="{ on: !assign }">이용권 양도</button>
                            <button @click="assign = !assign" :class="{ on: assign }">이용권 이전</button>
                        </div>
                        <div>
                            <table v-if="!assign" class="com-table left">
                                <colgroup>
                                    <col style="width: 160px" />
                                    <col style="width: 560px" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>
                                            회원명
                                            <span class="imp">*</span>
                                        </th>
                                        <td style="">
                                            <input
                                                v-model="editField.name"
                                                placeholder="회원명을 검색하세요"
                                                readonly
                                                type="text"
                                            />
                                            <div style="display: inline-block; margin-left: 10px; margin-right: 10px">
                                                >
                                            </div>
                                            <input
                                                v-model="transmissionParameter.name"
                                                placeholder="회원명을 검색하세요"
                                                readonly
                                                type="text"
                                            />
                                            <button class="com-btn" @click="onClickSearchCustomer">검색</button>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            유효기간
                                            <span class="imp">*</span>
                                        </th>
                                        <td style="height: 150px">
                                            <div style="position: absolute; top: 30%">
                                                <div style="margin-bottom: 5px">양도 전</div>
                                                <div class="input-cnt">
                                                    <template v-if="contractId">
                                                        <!-- 이용권 수정일 경우 -->
                                                        <single-calendar
                                                            disabled
                                                            :date="addedProdList[0].expireStartDt"
                                                        />
                                                        <div class="com-dash"><span class="dash">~</span></div>
                                                        <single-calendar
                                                            :disabledBeforeDate="transmissionParameter.OExpireStartDt"
                                                            :date="transmissionParameter.OExpireEndDt"
                                                            @update="(val) => (transmissionParameter.OExpireEndDt = val)"
                                                        />
                                                    </template>
                                                </div>
                                                <div style="margin-top: 5px; margin-bottom: 5px">양도 후</div>
                                                <div class="input-cnt">
                                                    <template v-if="contractId">
                                                        <!-- 이용권 수정일 경우 -->
                                                        <single-calendar
                                                            :disabledBeforeDate="transmissionParameter.OExpireEndDt"
                                                            :date="transmissionParameter.expireStartDt"
                                                            @update="(val) => (transmissionParameter.expireStartDt = val)"
                                                        />
                                                        <span class="dash">~</span>
                                                        <single-calendar
                                                            :disabledBeforeDate="transmissionParameter.OExpireStartDt"
                                                            :date="addedProdList[0].expireEndDt"
                                                            @update="(val) => (transmissionParameter.expireEndDt = val)"
                                                        />
                                                    </template>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>양도 정보</th>
                                        <td>
                                            <div class="input-cnt">
                                                <input
                                                    :value="
                                                        getTicketTypeString(
                                                            addedProdListInfo.centerContractProducts[0].centerProduct
                                                                .ticketType
                                                        ) +
                                                        ' ' +
                                                        addedProdListInfo.centerContractProducts[0].centerProduct.name +
                                                        ' ' +
                                                        getLessonCntString(
                                                            addedProdListInfo.centerContractProducts[0].centerProduct
                                                                .lessonCountType,
                                                            transmissionParameter.lessonCount
                                                        )
                                                    "
                                                    class="w400"
                                                    readonly
                                                    type="text"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>양도비</th>
                                        <td>
                                            <div class="input-cnt">
                                                <select-form
                                                    :select-data="payType.label"
                                                    :select-value="payType.value"
                                                    :selected-value="transmissionParameter.billingPayType"
                                                    class="w120"
                                                    :dropdown-style='{"max-height": "120px"}'
                                                    @update:set="(val) => (transmissionParameter.billingPayType = val)"
                                                />
                                                <select-form
                                                    v-if="transmissionParameter.billingPayType === 'C'"
                                                    :select-data="cardType.label"
                                                    :select-value="cardType.value"
                                                    :selected-value="transmissionParameter.billingPayCompany"
                                                    class="w120"
                                                    :dropdown-style='{"max-height": "120px"}'
                                                    @update:set="(val) => (transmissionParameter.billingPayCompany = val)"
                                                />

                                                <input
                                                    class="w180"
                                                    style="margin-left: 10px"
                                                    maxlength="12"
                                                    type="text"
                                                    v-model="transmissionParameter.fee"
                                                    @input="
                                                        transmissionParameter.fee = getNumberFormat(
                                                            getPureNumber(transmissionParameter.fee)
                                                        )
                                                    "
                                                    @keypress="isNumber($event)"
                                                />
                                                <span class="txt">원</span>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <table v-else class="com-table left">
                                <colgroup>
                                    <col style="width: 155px" />
                                    <col style="width: 560px" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>
                                            회원명
                                            <span class="imp">*</span>
                                        </th>
                                        <td>
                                            <input
                                                v-model="editField.name"
                                                placeholder="회원명을 검색하세요"
                                                readonly
                                                type="text"
                                            />
                                            <div style="display: inline-block; margin-left: 10px; margin-right: 10px">
                                                >
                                            </div>
                                            <input
                                                v-model="transmissionParameter.name"
                                                placeholder="회원명을 검색하세요"
                                                readonly
                                                type="text"
                                            />
                                            <button class="com-btn" @click="onClickSearchCustomer">검색</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div style="margin: 5px; display: grid">
                            <span class="red">
                                <span class="imp">*</span>
                                양도 후 이용권 복원이 불가하오니 정확히 입력해 주세요.
                            </span>
                            <span v-if="assign" class="red">
                                <span class="imp">*</span>
                                이용권 이전 시 기존 회원의 예약,정산,매출이력은 모두 이용권 이전 대상의 회원명으로
                                변경됩니다.
                            </span>
                            <span v-if="assign" class="red">
                                <span class="imp">*</span>
                                남은 횟수만 양도 시 이용권 양도를 이용해 주세요 해당 기능은 강사 정산 시 이용권 '고정
                                퍼센트'를 사용하시는 센터만 이용 부탁드립니다.
                            </span>
                        </div>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="transmissionPop = false">취소</button>
                            <button
                                class="com-btn blue"
                                @click="
                                    onClickTransmission(
                                        addedProdListInfo.centerContractProducts[0].centerProduct.lessonCountType,
                                        assign
                                    )
                                "
                            >
                                양도
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 회원 검색 팝업 -->
            <div v-show="userPop" class="layer-pop square-type">
                <div class="view-content">
                    <div class="scroll-area com-scroll-y">
                        <span class="sub-title">회원 검색 결과</span>
                        <div class="top-search-area">
                            <div class="right">
                                <input
                                    ref="refCustomerName"
                                    v-model="searchCustomerStr"
                                    class="w220"
                                    placeholder="회원명"
                                    type="text"
                                    v-on:keyup.enter="onSearchCustomer"
                                />
                                <button class="com-btn" @click="onSearchCustomer">검색</button>
                            </div>
                        </div>
                        <table class="com-table">
                            <colgroup>
                                <col style="width: 70px" />
                                <col style="width: 120px" />
                                <col style="width: 160px" />
                                <col style="width: 160px" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>회원명</th>
                                    <th>연락처</th>
                                    <th>생년월일</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(c, index) in searchCustomerList" :key="index">
                                    <td>
                                        <div class="com-radio">
                                            <input
                                                :id="`radio-pop-${index + 1}`"
                                                v-model="pickedCustomerId"
                                                :value="c.center_cust_id"
                                                name="radio-pop"
                                                type="radio"
                                            />
                                            <label :for="`radio-pop-${index + 1}`"></label>
                                        </div>
                                    </td>
                                    <td>{{ c.namee }}</td>
                                    <td>{{ c.phone | customerPhoneFilter }}</td>
                                    <td>{{ getDateFormatFilter(c.birthday) }}</td>
                                </tr>
                                <tr v-if="searchCustomerList.length === 0">
                                    <td colspan="100">등록된 내용이 없습니다.</td>
                                </tr>
                            </tbody>
                        </table>
                        <b-pagination
                            v-model="pagingInfo.page"
                            :per-page="pagingInfo.limit"
                            :total-rows="pagingInfo.totalItems"
                            align="center"
                            aria-controls="my-table"
                            first-class="first"
                            last-class="last"
                            next-class="next"
                            prev-class="prev"
                            @change="handlerPagenation($event)"
                        ></b-pagination>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="onClickCancleSearchPop">취소</button>
                            <button class="com-btn blue" @click="onClickPickCustomer">선택</button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import LoadingSpinner from '@/components/LoadingSpinner';
import { validateNumber } from '../../../assets/js/validation';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';
import { Utils } from '@/assets/js/utils';
import { pagingInfo, TICKET_TYPES } from '@/assets/js/common';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
    name: 'memberNew',
    mixins: [MixinAllowedMenu],
    components: { LoadingSpinner, PerfectScrollbar },
    props: {},
    watch: {
        refundPop() {
            if (this.refundPop) {
                this.returnPayType = 'L'; // 환불 결재수단 코드 (카드 = C, 현금 = L, 계좌이체 = B)
            } else {
                this.init();
            }
        },
        'transmissionParameter.OExpireEndDt': function (value) {
            this.transmissionParameter.expireStartDt = moment(value).add(1, 'days').format('YYYY-MM-DD');
            api.get(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${this.contractId}/date/${this.transmissionParameter.OExpireEndDt}`
            ).then((res) => {
                this.transmissionParameter.reservationCount = res.data.afterReservation;
                this.transmissionParameter.beforeReservationCount = res.data.beforeReservation;
                this.transmissionParameter.lessonCount =
                    this.addedProdListInfo.centerContractProducts[0].lessonCount -
                    (this.addedProdListInfo.centerContractProducts[0].lessonJoinCount +
                        this.addedProdListInfo.centerContractProducts[0].lessonAbsentCount);
                this.transmissionParameter.beforeUseCount =
                    this.addedProdListInfo.centerContractProducts[0].lessonJoinCount +
                    this.addedProdListInfo.centerContractProducts[0].lessonAbsentCount;
            });
        },
    },
    computed: {
        prodIsT() {
            // 선택된 상품이 이용권이면 true
            return this.addedProdListInfo.productType === 'T';
        },
        prodIsP() {
            return this.addedProdListInfo.productType === 'P';
        },
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        centerStaffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
        totalProductCount() {
            // 이용권 개수 합계
            return this.addedProdList.length;
        },
        totalOrgPrice() {
            // 정상가 합계
            let price = 0;
            this.addedProdList.forEach((p) => (price += this.getPureNumber(p.productOrgPrice)));
            return this.getNumberFormat(price);
        },
        totalBuyPrice() {
            // 실제구매가 합계
            let price = 0;
            this.addedProdList.forEach((p) => (price += this.getPureNumber(p.productBuyPrice)));
            return this.getNumberFormat(price);
        },
        /*
    고객 요구에 의해서 삭제
    totalLessonCount() { // 이용권 횟수 합계
        let count = 0;
        this.addedProdList.forEach((p) => count += parseInt(p.lessonCount));
        return count;
    },
    */
        totalBillPrice() {
            // 결제 금액 합계
            let billPrice = 0;
            this.editField.bills.forEach((b) => {
                billPrice += b.billPrice;
                // if(b.hasOwnProperty('spendMileage')){
                //     billPrice += b.spendMileage;
                // }
            });
            return billPrice;
        },
        totalDebtPrice() {
            // 미수 금액 합계
            let debtPrice = 0;
            debtPrice = this.getPureNumber(this.totalBuyPrice) - this.getPureNumber(this.totalBillPrice);

            return this.getNumberFormat(debtPrice);
        },
        moreBillable() {
            let locked = 0;
            this.editField.bills.forEach((b) => {
                locked += b.billPrice || b.npReqPrice || 0;
            });

            return this.getPureNumber(this.totalBuyPrice) > this.getPureNumber(locked);
        },
        billCount() {
            const count = this.editField.bills.length;
            return count || 0;
        },
        totalReturnPrice() {
            // 환불 금액 합계
            let returnPrice = 0;
            this.addedProdList.forEach((p) => {
                if (p.returnPrice !== null) {
                    returnPrice += this.getPureNumber(p.returnPrice);
                }
            });
            return this.getNumberFormat(returnPrice);
        },
        today() {
            // 오늘 날짜 반환
            return moment().format('YYYY-MM-DD');
        },
        centerChains() {
            // 체인 목록 [본점, 지점, 지점...] (체인점 최고권한자만 값이 있음)
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
        memo() {
            const m = this.contractId ? this.addedProdListInfo.memo : this.editField.memo;
            return m ? m : '';
        },
    },
    created() {
        this.TICKET_TYPES = TICKET_TYPES;
        this.MEMO_MAX_LEN = 1000;
    },
    mounted() {
        this.centerId = parseInt(this.cId); // 센터 Id
        this.chainCenter = parseInt(this.cId);
        this.init();
    },
    beforeRouteLeave(to, from, next) {
        if (this.billCount > 0 || window.confirm('결제정보가 없습니다. 계속 하시겠습니까?')) {
            next();
        } else {
            next(false);
        }
    },
    data() {
        return {
            assign: false,
            userPop: false,
            refundPop: false,
            isLoading: false, // 페이지 로딩
            productIsLoading: false, // 이용권 로딩
            returnIsLoading: false, // 환불 팝업 로딩

            centerChainList: [], // 본점 + 지점 체인점 목록
            customerInfo: {}, // 회원 정보
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId ? this.$route.query.customerId : '',
            contractId: this.$route.query.contractId,
            editField: {
                name: '',
                regStaffId: '',
                bills: [],
            },
            centerProdInfo: [], // 센터 상품 목록 (이용권)
            centerProdTypeList: [], // 센터 상품 이름 목록 (select-form 전용)
            centerProdTypeValueList: [], // 센터 상품 ID 목록 (select-form 전용)

            searchCustomerStr: '', // 회원 검색 키워드
            searchCustomerList: [], // 검색된 회원 목록
            pickedCustomerId: '', // 선택한 회원의 customerId
            pagingInfo: { ...pagingInfo }, // 회원 검색 팝업 페이징 파라미터

            selectedProdType: '',
            selectedProd: '', // 선택된 이용권
            addedProdListInfo: {}, // 추가된 이용권 목록 (가공 전)
            addedProdList: [], // 추가된 이용권 목록 (가공 후)
            addedProductType: '', // 추가된 이용권 타입 (T : 이용권, P : 패키지)

            searchProdKeyword: '',

            centerStaffList: [], // centerStaff 이름 목록
            centerStaffValueList: [], // centerStaff ID 목록

            chainCenterType: [], // 체인 센터명 배열
            chainCenterTypeValue: [], // 체인 센터 Id 배열
            chainCenter: '',

            returnStaffId: '', // 환불 직원 id
            returnMileagePrice: '', // 환불 마일리지 차감 금액
            returnPayType: 'L', // 환불 결재수단 코드 (카드 : C, 현금 : L, 계좌이체 : B)
            returnPayBank: '', // 환불 은행 (KB국민카드 : KB, 비씨 : BC, 삼성 : SM, 현대 : HY, 롯데 : LO, 신한 : SH, 하나 : HA, NH농협 : NH)
            returnPayOwn: '', // 환불 예금주
            returnPayAccount: '', // 환불 계좌번호
            returnMemo: '', // 환불 사유
            returnPrice: '', // 환불 합계 금액
            returnApplyAt: '', // 환불 신청일

            returnModify: false,

            periodInfoList: [], // 유효 기간 정보들의 목록

            // 기간연장 및 연장내역에 관한 데이터
            periodPop: false, // 컴포넌트 period-pop을 화면에 보여지는 것을 결정하는 데이터
            periodPopProps: {}, // 컴포넌트 period-pop의 props를 모아놓은 객체

            // 마일리지 설정 정보
            mileageInfo: {},

            returnYn: false,
            countMessage: '',
            transmissionPop: false,
            transmissionParameter: {
                fee: 0,
                OExpireStartDt: null,
                OExpireEndDt: moment().subtract(1, 'days').format('YYYY-MM-DD'),
                expireStartDt: moment().format('YYYY-MM-DD'),
                expireEndDt: '',
                name: '',
                billingPayType: 'C',
                billingPayCompany: '',
                get_trans_yn: true,
            },
            cardType: {
                label: [
                    '선택',
                    'KB국민카드',
                    '비씨',
                    '삼성',
                    '현대',
                    '롯데',
                    '신한',
                    '하나',
                    'NH농협',
                    '외환',
                    '우리',
                    '기타',
                ],
                value: ['', 'KB', 'BC', 'SM', 'HY', 'LO', 'SH', 'HA', 'NH', 'WR', 'WT', 'ET'],
            },
            payType: {
                label: ['카드', '현금', '계좌이체', '기타'],
                value: ['C', 'L', 'B', 'E'],
            },
            selectPayType: 'L',
            selectCardType: 'KB',
        };
    },

    methods: {
        async onClickTransmission(lessonCountType, assign) {
            this.isLoading = true;
            const {
                expireStartDt,
                expireEndDt,
                reservationCount,
                lessonCount,
                fromCenterCustomerId,
                toCenterCustomerId,
            } = this.transmissionParameter;
            if (!fromCenterCustomerId) {
                alert('양도할 회원정보가 없습니다.');
                this.isLoading = false;
                return;
            }
            if (!toCenterCustomerId) {
                alert('양도받을 회원을 선택해주세요.');
                this.isLoading = false;
                return;
            }
            if (fromCenterCustomerId == toCenterCustomerId) {
                alert('양도할 회원과 양도 받을 회원의 정보가 일치합니다.');
                this.isLoading = false;
                return;
            }
            if (!expireStartDt) {
                alert('양도 후 이용권 사용 시작일자를 확인해주세요');
                this.isLoading = false;
                return;
            }
            if (!expireEndDt) {
                alert('양도 후 이용권 사용 종료일자를 확인해주세요');
                this.isLoading = false;
                return;
            }
            if (reservationCount != 0 && assign === false) {
                alert('양도할 이용권으로 예약된 내역이 존재합니다. 예약취소 후 다시 진행해주세요.');
                this.isLoading = false;
                return;
            }
            if (lessonCount < 0) {
                if (
                    this.addedProdListInfo.centerContractProducts[0].centerProduct.ticketType !== 'C' &&
                    this.addedProdListInfo.centerContractProducts[0].centerProduct.ticketType !== 'T' &&
                    lessonCountType !== 'U'
                ) {
                    alert('양도할 이용권의 사용횟수를 모두 소진하였습니다.');
                    this.isLoading = false;
                    return;
                }
            }
            this.transmissionParameter.fee = this.getPureNumber(this.transmissionParameter.fee);
            try {
                const { data } = await api.post(
                    `/admin/api/center/${this.centerId}/customer/${fromCenterCustomerId}/contract/transmission`,
                    {
                        ...this.transmissionParameter,
                        is_complete_trans: assign,
                    }
                );
                if (data === true) {
                    alert(
                        `${this.transmissionParameter.name}님에게 ${
                            this.getTicketTypeString(
                                this.addedProdListInfo.centerContractProducts[0].centerProduct.ticketType
                            ) +
                            ' ' +
                            this.addedProdListInfo.centerContractProducts[0].centerProduct.name +
                            ' ' +
                            this.getLessonCntString(
                                this.addedProdListInfo.centerContractProducts[0].centerProduct.lessonCountType,
                                this.transmissionParameter.lessonCount
                            )
                        }을 양도하였습니다.`
                    );
                    this.$router.back();
                }
            } catch (e) {
                alert('이용권 양도 중 에러가 발생하였습니다.');
            }
            this.isLoading = false;
        },
        openTransmissionPop() {
            this.transmissionParameter = {
                fee: 0,
                OExpireStartDt: this.addedProdList[0].expireStartDt,
                OExpireEndDt: moment().subtract(1, 'days').isBefore(this.addedProdList[0].expireStartDt)
                    ? moment(this.addedProdList[0].expireStartDt).format('YYYY-MM-DD')
                    : moment().subtract(1, 'days').format('YYYY-MM-DD'),
                expireStartDt: moment().add(1, 'days').format('YYYY-MM-DD'),
                expireEndDt: this.addedProdList[0].expireEndDt,
                name: '',
                fromCenterCustomerId: this.customerId,
                centerContractId: this.contractId,
                billingPayType: 'C',
                billingPayCompany: '',
                get_trans_yn: true,
            };
            api.get(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${this.contractId}/date/${this.transmissionParameter.OExpireEndDt}`
            ).then((res) => {
                this.transmissionParameter.reservationCount = res.data.afterReservation;
                this.transmissionParameter.beforeReservationCount = res.data.beforeReservation;
                this.transmissionParameter.lessonCount =
                    this.addedProdListInfo.centerContractProducts[0].lessonCount -
                    (this.addedProdListInfo.centerContractProducts[0].lessonJoinCount +
                        this.addedProdListInfo.centerContractProducts[0].lessonAbsentCount);
                this.transmissionPop = true;
            });
        },
        // 초기화
        async init() {
            this.isLoading = true;
            this.centerId = parseInt(this.cId); // 로그인한 센터 id
            this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음
            await this.getCenterInfo(); // 로그인한 센터 정보 가져오기
            await this.getMileageInfo();
            if (this.centerChainList.length === 0) {
                // 체인점 최고 관리자가 아닌 일반 센터 관리자 및 직원일 경우 접속한 아이디에 해당하는 센터만 센터 목록에 보임
                this.chainCenterType.push(this.centerInfo.centerName);
                this.chainCenterTypeValue.push(this.centerInfo.id);
                this.centerId = this.centerInfo.id;
            } else if (this.centerChainList.length !== 0) {
                // 체인점 최고 권한자일 경우 체인점에 속한 모든 센터가 목록에 보임
                this.centerChainList.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.centerId);
                    this.centerId = this.centerInfo.id; // 접속한 centerId가 기본으로 선택 되게끔 함
                });
            }

            if (this.customerId) {
                // 이미 등록된 회원일 경우 customerId가 있음
                await this.fetchCustomerDetail(this.customerId); // customerId로 customer 정보 가져오기
            }
            if (this.contractId) {
                // 이용권 정보 수정일 경우
                await this.fetchContractDetail(this.contractId); // contractId로 contract 정보 가져오기
                this.returnYn = this.addedProdList[0].returnYn;
            }
            if (!this.contractId) {
                // 신규 등록일때만 빈 결제 정보 1개 셋팅
                await this.fetchCenterProdList(); // 센터 이용권 목록 가져오기
                await this.addBills(); // 결제 정보 기본 셋팅
            }
            await this.fetchCenterStaffList(); // 매출직원, 담당강사 목록 가져오기
            // await this.fetchChainCenter(); // 체인점 대표일 경우 센터 목록 가져오기
            this.isLoading = false;
            this.editField.regStaffId = Number(this.centerStaffId);
        },

        // 이용권 수정시 이용권 데이터 가져오기
        async fetchContractDetail(contractId) {
            try {
                const { data } = await this.sendGetContractDetail(contractId);
                console.log('데이터', data);
                this.addedProdListInfo = data;
                if (this.addedProdListInfo.productType === 'P') {
                    // 패키지일 경우
                    data.centerContractProducts.forEach((c, index) => {
                        this.addedProdList.push(c);
                    });
                } else {
                    // 이용권일 경우
                    this.addedProdList = data.centerContractProducts;
                    this.returnPayType = this.addedProdList[0].returnPayType;
                    console.log(this.addedProdList[0].returnPayType);
                }
                // 가져온 회원 계약 정보의 결제내역은 bills에 넣어줌
                this.editField.bills = this.make_bills(data.centerContractBills);
            } catch (error) {
                alert('이용권 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },
        make_bills(data) {
            for (const i in data) {
                data[i].mode = 'read';
                data[i].billDate = data[i].buyDate;
                data[i].acmltMileagePrice = 0;

                if (data[i].payType === 'M') {
                    data[i].spendMileage = data[i].billPrice;
                }
            }
            return data;
        },
        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },

        // 센터회원계약 조회 API 호출
        sendGetContractDetail(contractId) {
            // 스웨거 검색: 센터회원계약 조회
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${contractId}`);
        },

        // 이용권 등록 버튼 클릭시
        async onClickRegistContract() {
            try {
                const validate = this.validateValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                if (!confirm('이용권을 등록하시겠습니까?')) {
                    return false;
                }
                this.isLoading = true;

                const { data } = await this.sendPostRegistContract();

                const isUrlPayment = this.editField.bills.some((b) => b.payType === 'U');
                alert(
                    `이용권이 등록 되었습니다. \n ${
                        isUrlPayment
                            ? '회원님에게 URL결제요청 하였습니다. \n 회원님이 결제를 완료하면 결제정보가 자동으로 등록됩니다.'
                            : ''
                    }`
                );
                this.isLoading = false;

                await this.$router.push({
                    path: `../payment/${this.centerId}`,
                    query: { customerId: this.customerId },
                });
            } catch (error) {
                this.isLoading = false;
                if (error && error.response.data) {
                    const errMsg = error.response.data.error || '';
                    if (errMsg.includes('URL결제')) {
                        alert('URL결제요청 실패 하였습니다.');
                        return;
                    }
                }
                alert('이용권 등록 중 오류가 발생했습니다.');
            }
        },

        // 스웨거 검색: 센터회원계약 등록
        sendPostRegistContract() {
            const params = this.getRegistParams();
            if (params) {
                return api.post(`/admin/api/center/${this.centerId}/customer/${this.customerId}/contract`, {
                    ...params,
                });
            }
        },

        // 센터회원계약 등록 파라미터 가공
        getRegistParams() {
            const { editField, addedProdList } = this;
            const bills = [];
            let totalSpendMileage = 0; // 마일리지 사용 금액 총합
            let totalEtcPrice = 0; // 기타 할인 금액 총합
            editField.bills.forEach((b, index) => {
                const temp = {
                    debtYn: false,
                    billSeq: index,
                    buyDate: b.billDate, // 결제 일자
                    billPrice: b.payType === 'M' ? b.spendMileage : b.billPrice, // 결제 금액
                    npReqPrice: b.payType === 'U' ? b.npReqPrice : 0,
                    payType: b.payType, // 결제 수단
                    payCardType: b.payCardType, // 결제 카드 유형
                    payBankType: b.payBankType, // 결제 은행 유형
                    mileage: this.getPureNumber(b.acmltMileagePrice), // 적립 차감 마일리지
                    receiptType: b.receiptType, // 영수증 발행 유형 코드
                    receiptNo: b.receiptNo, // 영수증 발행 번호
                    npTid: '', // 핏페이 현장결제 거래아이디
                    npCardType: '', // 핏페이 카드유형
                    npCardNum: '', // 핏페이 카드번호
                    npAppNum: '', // 핏페이 승인번호
                };
                if (b.payType === 'M') {
                    // 결제수단이 마일리지일 때 마일리지 사용 금액 총합에 더해줌
                    totalSpendMileage += b.spendMileage;
                }
                if (b.payType === 'E') {
                    // 결제수단이 기타일 때 기타 결제 금액을 총합에 더해줌
                    totalEtcPrice += b.billPrice;
                }
                if (b.payType !== 'L' && b.payType !== 'B') {
                    // 현금, 계좌이체가 아닐때 영수증 관련 파라미터는 삭제
                    delete temp.receiptType;
                    delete temp.receiptNo;
                }
                if (b.payType !== 'C') {
                    // 카드가 아닐때 카드 파라미터 삭제
                    delete temp.payCardType;
                }
                if (b.payType !== 'B') {
                    // 계좌이체가 아닐때 은행 파라미터 삭제
                    delete temp.payBankType;
                }
                if (b.payType === 'T') {
                    temp.npTid = b.npTid; // 핏페이 현장결제 거래아이디
                    temp.npCardType = b.npCardType; // 핏페이 카드유형
                    temp.npCardNum = b.npCardNum; // 핏페이 카드번호
                    temp.npAppNum = b.npAppNum; // 핏페이 승인번호
                    // temp.npInstallment = ''; // 핏페이 할부
                }
                if (this.totalDebtPrice > 0) {
                    temp.debtYn = true;
                }
                bills.push(temp);
            });

            const products = [];
            addedProdList.forEach((p) => {
                // 이용권 목록 가공
                const temp = {
                    centerProductId: this.getPureNumber(p.centerProductId),
                    centerProductVersion: this.getPureNumber(p.centerProductVersion),
                    productOrgPrice: this.getPureNumber(p.productOrgPrice),
                    productBuyPrice: this.getPureNumber(p.productBuyPrice),
                    saleStaffId: p.saleStaffId || null,
                    saleStaffContractType: p.saleStaffContractType,
                    lessonStaffId: p.lessonStaffId,
                    lessStaffContractType: p.lessStaffContractType,
                    expireStartDt: p.expireStartDt,
                    expireEndDt: p.expireEndDt,
                    lessonCountType: p.lessonCountType,
                    lessonCount: this.getPureNumber(p.lessonCount),
                    turnBillPrice: this.getPureNumber(p.turnBillPrice),
                    lessonResverStaffYn: p.lessonResverStaffYn,
                };
                if (Utils.isEmpty(this.getPureNumber(p.turnBillPrice))) {
                    delete temp.turnBillPrice;
                }
                // if (Utils.isEmpty(p.saleStaffId)) {
                //   delete temp.saleStaffId;
                // }
                if (Utils.isEmpty(p.lessonStaffId)) {
                    delete temp.lessonStaffId;
                }
                products.push(temp);
            });

            const params = {
                contractType: 'N', // 계약 유형 코드 (신규계약 : N, 재등록 : R, 환불 : C)
                productType: this.addedProdListInfo.productType, // 구매상품 유형 코드 (이용권 : T, 패키지 : P, 락커 : L, 부가상품 : S)
                totalProductCount: addedProdList.length, // 전체상품갯수
                totalOrgPrice: this.getPureNumber(this.totalOrgPrice), // 전체정상가격
                totalBuyPrice: this.getPureNumber(this.totalBuyPrice), // 전체실구매가격
                regStaffId: parseInt(editField.regStaffId), // 입력자직원아이디
                mileageUsePrice: totalSpendMileage, // 마일리지 사용금액
                etcDiscountPrice: totalEtcPrice, // 기타 할인금액
                retunYn: 'N', // 환불 여부
                centerProductId: this.getPureNumber(this.addedProdListInfo.centerProductId), // 센터상품아이디
                centerProductVersion: this.getPureNumber(this.addedProdListInfo.centerProductVersion), // 센터상품버젼
                totalDebtPrice: this.getPureNumber(this.totalDebtPrice), // 전체 미수금
                memo: editField.memo, // 메모
                products, // 센터회원 계약 상품
                bills, // 센터회원 계약 결제정보
            };
            return params;
        },

        // 파라미터 validate
        validateValues() {
            // 필수값 체크
            let result = false;
            const { editField, centerId, customerId, addedProdList } = this;
            let msg = '';

            // 센터
            if (centerId === '' || centerId === undefined) {
                msg = '센터를 선택하세요.';
                return { result, msg };
            }

            // 회원명
            if (customerId === '') {
                msg = '회원을 선택하세요.';
                return { result, msg };
            }

            // 이용권
            if (addedProdList.length === 0) {
                msg = '이용권을 선택하세요.';
                return { result, msg };
            }

            // 입력자
            if (!this.contractId && editField.regStaffId === '') {
                msg = '입력자를 선택하세요.';
                return { result, msg };
            }
            // 수정일 때 입력자
            if (this.contractId && this.addedProdListInfo.regStaffId === '') {
                msg = '입력자를 선택하세요.';
                return { result, msg };
            }
            // 횟수
            if (this.countMessage === '예약되어있는 횟수 보다 낮은 값을 넣을 수 없습니다.') {
                msg = '예약되어있는 횟수 보다 낮은 값을 넣을 수 없습니다.';
                return { result, msg };
            }
            // 결제정보 은행여부
            if (this.billCount === 0) {
                msg = '결제정보추가 해주세요.';
                return { result, msg };
            }
            if (this.editField.bills[0].payType === 'C' && this.editField.bills[0].payCardType === '') {
                msg = '카드를 선택해주세요.';
                return { result, msg };
            }

            // 추가된 이용권들의 유효기간, 실제구매가, 매출직원, 담당강사 체크
            addedProdList.some((p, index) => {
                if (Utils.isEmpty(p.expireStartDt) || Utils.isEmpty(p.expireEndDt)) {
                    msg = `${index + 1}번째 이용권의 유효기간을 선택하세요.`;
                    return true;
                }

                if (Utils.isEmpty(p.productBuyPrice)) {
                    msg = `${index + 1}번째 이용권의 실제구매가를 입력하세요.`;
                    return true;
                } else if (!validateNumber(this.getPureNumber(p.productBuyPrice))) {
                    msg = `${index + 1}번째 이용권의 실제구매가를 다시 입력하세요.`;
                    return true;
                }

                if (Utils.isEmpty(p.lessonCount)) {
                    // p.lessonCount === 0 || p.lessonCount === '0'
                    msg = `${index + 1}번째 이용권의 횟수를 입력하세요.`;
                    return true;
                } else if (!validateNumber(p.lessonCount)) {
                    msg = `${index + 1}번째 이용권의 횟수를 다시 입력하세요.`;
                    return true;
                }

                if (p.turnBillPrice && !validateNumber(this.getPureNumber(p.turnBillPrice))) {
                    msg = `${index + 1}번째 이용권의 1회당 정산금액을 다시 입력하세요.`;
                    return true;
                }
            });

            // 결제 후 미수금액 체크
            if (this.getPureNumber(this.totalBuyPrice) - this.getPureNumber(this.totalBillPrice) < 0) {
                // 총 구매 금액 - 총 결제 금액 = 총 미수 금액
                msg = '결제금액이 결제 예정 금액보다 큽니다. 결제 금액을 수정하세요.';
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },

        // 이용권 수정 버튼 클릭시
        async onClickModifyContract() {
            try {
                const validate = this.validateValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                if (!confirm('이용권을 수정하시겠습니까?')) {
                    return false;
                }
                this.isLoading = true;
                const { data } = await this.sendPutModifyContract();
                alert('이용권이 수정 되었습니다.');
                this.isLoading = false;
                this.$router.push({
                    path: `/madmin/member/payment/${this.centerId}`,
                    query: { customerId: this.customerId },
                });
            } catch (error) {
                this.isLoading = false;
                alert('이용권 수정 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 이용권 수정 API 호출
        sendPutModifyContract() {
            // 스웨거 검색: 센터회원계약 수정
            const params = this.getModifyParams();
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${this.contractId}`,
                {
                    ...params,
                }
            );
        },

        // 센터회원계약 수정 파라미터 가공
        getModifyParams() {
            const { editField, addedProdList, addedProdListInfo } = this;
            const bills = [];
            let totalSpendMileage = 0; // 마일리지 사용 금액 총합
            let totalEtcPrice = 0; // 기타 할인 금액 총합
            editField.bills.forEach((b, index) => {
                const temp = {
                    debtYn: false,
                    billSeq: b.billSeq,
                    buyDate: b.billDate, // 결제 일자
                    billPrice: this.getPureNumber(b.billPrice), // 결제 금액
                    payType: b.payType, // 결제 수단
                    payCardType: b.payCardType, // 결제 카드 유형
                    payBankType: b.payBankType, // 결제 은행 유형
                    mileage: this.getPureNumber(b.acmltMileagePrice), // 적립 차감 마일리지
                    // mileage: null, // 적립 차감 마일리지
                    receiptType: b.receiptType, // 영수증 발행 유형 코드
                    receiptNo: this.getPureReceiptNo(b.receiptNo), // 영수증 발행 번호
                    npTid: '', // 핏페이 현장결제 거래아이디
                    npCardType: '', // 핏페이 카드유형
                    npCardNum: '', // 핏페이 카드번호
                    npAppNum: '', // 핏페이 승인번호
                    npReqPrice: b.payType === 'U' ? this.getPureNumber(b.npReqPrice) : 0, // 결제 금액
                };
                if (b.payType === 'T' || b.payType === 'U') {
                    // 핏페이일 경우
                    temp.npTid = b.npTid;
                    temp.npCardType = b.npCardType;
                    temp.npCardNum = b.npCardNum;
                    temp.npAppNum = b.npAppNum;
                }
                if (b.payType === 'M') {
                    // 결제수단이 마일리지일 때 마일리지 사용 금액 총합에 더해줌
                    totalSpendMileage += b.spendMileage;
                }
                if (b.payType === 'E') {
                    // 결제수단이 기타일 때 기타 결제 금액을 총합에 더해줌
                    totalEtcPrice += b.billPrice;
                }
                if (b.payType !== 'L' && b.payType !== 'B') {
                    // 현금, 계좌이체가 아닐때 영수증 관련 파라미터는 삭제
                    delete temp.receiptType;
                    delete temp.receiptNo;
                }
                if (b.payType !== 'C') {
                    // 카드가 아닐때 카드 파라미터 삭제
                    delete temp.payCardType;
                }
                if (b.payType !== 'B') {
                    // 계좌이체가 아닐때 은행 파라미터 삭제
                    delete temp.payBankType;
                }
                if (this.totalDebtPrice !== 0) {
                    temp.debtYn = true;
                }
                bills.push(temp);
            });

            const products = [];
            addedProdList.forEach((p) => {
                // 이용권 목록 가공
                const temp = {
                    returnUsePrice: this.getPureNumber(p.returnUsePrice),
                    returnPrice: this.getPureNumber(p.returnPrice),
                    returnMileagePrice: this.getPureNumber(p.returnMileagePrice),
                    returnPayType: p.returnPayType,
                    returnMemo: p.returnMemo,
                    returnStaffId: p.returnStaffId,
                    returnApplyAt: p.returnApplyAt,

                    centerProductId: this.getPureNumber(p.centerProductId),
                    centerProductVersion: this.getPureNumber(p.centerProductVersion),
                    contractProductSeq: p.contractProductSeq,
                    productOrgPrice: this.getPureNumber(p.productOrgPrice),
                    productBuyPrice: this.getPureNumber(p.productBuyPrice),
                    saleStaffId: p.saleStaffId,
                    saleStaffContractType: p.saleStaffContractType,
                    lessonStaffId: p.lessonStaffId,
                    lessStaffContractType: p.lessStaffContractType,
                    expireStartDt: p.expireStartDt,
                    expireEndDt: p.expireEndDt,
                    lessonCountType: p.lessonCountType,
                    lessonCount: this.getPureNumber(p.lessonCount),
                    turnBillPrice: this.getPureNumber(p.turnBillPrice),
                    lessonResverStaffYn: p.lessonResverStaffYn,
                };
                if (this.getPureNumber(p.turnBillPrice) === '') {
                    delete temp.turnBillPrice;
                }
                products.push(temp);
            });

            const params = {
                contractType: 'N', // 계약 유형 코드 (신규계약 : N, 재등록 : R, 환불 : C)
                productType: this.addedProdListInfo.productType, // 구매상품 유형 코드 (이용권 : T, 패키지 : P, 락커 : L, 부가상품 : S)
                totalProductCount: addedProdList.length, // 전체상품갯수
                totalOrgPrice: this.getPureNumber(this.totalOrgPrice), // 전체정상가격
                totalBuyPrice: this.getPureNumber(this.totalBuyPrice), // 전체실구매가격
                regStaffId: parseInt(addedProdListInfo.regStaffId), // 입력자직원아이디
                mileageUsePrice: totalSpendMileage, // 마일리지 사용금액
                etcDiscountPrice: totalEtcPrice, // 기타 할인금액
                retunYn: 'N', // 환불 여부
                centerProductId: this.getPureNumber(this.addedProdListInfo.centerProductId), // 센터상품아이디
                centerProductVersion: this.getPureNumber(this.addedProdListInfo.centerProductVersion), // 센터상품버젼
                totalDebtPrice: this.getPureNumber(this.totalDebtPrice), // 전체 미수금
                // lockerNo: '', // 락커 번호
                memo: addedProdListInfo.memo, // 메모
                products, // 센터회원 계약 상품
                bills, // 센터회원 계약 결제정보
            };

            return params;
        },

        // 매출직원, 담당강사 목록 가져오기
        async fetchCenterStaffList() {
            try {
                this.centerStaffList = [];
                this.centerStaffValueList = [];
                const { data } = await this.sendGetCenterStaffList();
                data.forEach((d) => {
                    this.centerStaffList.push(d.name);
                    this.centerStaffValueList.push(d.centerStaffId);
                });
            } catch (error) {
                alert('직원 목록을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 직원 목록 API 호출
        sendGetCenterStaffList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/teachers/list`);
        },

        // 소속 체인점 센터 조회
        async fetchChainCenter() {
            try {
                const { data } = await this.sendGetChainCenter();
                data.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.id);
                });
            } catch (error) {
                console.log(error);
            }
        },

        // 소속 체인점 센터 조회 API 호출
        sendGetChainCenter() {
            let centerId;
            this.chainCenter === '' ? (centerId = this.centerId) : (centerId = this.chainCenter);
            return api.get(`/admin/api/center/${centerId}/chain`);
        },

        // 센터 회원 기본 정보 가져오기
        async fetchCustomerDetail(customerId, isTransmission) {
            try {
                const { data } = await this.sendGetCustomerDetail(customerId);
                if (isTransmission) {
                    this.transmissionParameter.name = data.name; // 가져온 그대로 customerInfo에 넣기
                } else {
                    this.customerInfo = data; // 가져온 그대로 customerInfo에 넣기
                    const { editField } = this;
                    editField.name = this.customerInfo.name;
                }
            } catch (error) {
                alert('회원 정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 기본 정보 조회 API 호출
        sendGetCustomerDetail(customerId) {
            return api.get(`/admin/api/center/${this.centerId}/customer/${customerId}`);
        },

        // 센터 상품 목록 fetch
        async fetchCenterProdList() {
            try {
                const { data } = await this.sendGetCenterProdList();
                this.centerProdInfo = data;

                this.arrangeProdInfo(this.centerProdInfo); // 받아온 이용권 목록을 변수에 셋팅
            } catch (error) {
                alert('이용권 목록을 불러오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 받아온 센터 상품 목록으로 select-form에 나타내기 위해 정리
        arrangeProdInfo(data) {
            // 상품 유형 코드(productType) - T : 이용권(Ticket),  P : 패키지(Package), L : 락커, C : 트레이닝복, S : 부가상품(Sub Product)
            // 이용권_유형_코드(ticketType) - P : 개인,  O : OT,  D : 듀엣,  G : 그룹,  C : 쿠폰,  T : 회원권
            // 수업_횟수_유형_코드(lessonCountType) - T : 총횟수(Total),  W : 주당횟수(Week),  U : 무제한(Unlimit)
            //
            // '[이용권구분] 이용권명' 또는
            // '[패키지] 패키지명' 으로 불러온다.
            //
            //  노출 순서는
            // [이용권 구분] 회원권>개인>OT>듀엣>그룹>쿠폰>패키지 순이다.
            // 이용권 구분 후 이용권명 ㄱㄴㄷ 순이다.

            const types = Object.keys(TICKET_TYPES);
            this.centerProdTypeValueList.splice(0);

            this.centerProdTypeValueList = data
                .filter((prod) => {
                    if (!prod.stockUseYn) {
                        return false;
                    }

                    if (this.selectedProdType && prod.ticketType !== this.selectedProdType) {
                        return false;
                    }

                    if (this.searchProdKeyword && !prod.name.includes(this.searchProdKeyword)) {
                        return false;
                    }

                    return true;
                })
                .map((prod) => {
                    const { ticketType, lessonCountType, lessonCount, periodType, periodCount, ...rest } = prod;
                    const cntTxt =
                        lessonCountType === 'T' || lessonCountType === 'W'
                            ? `${lessonCountType === 'W' ? '주' : ''}${lessonCount}회`
                            : '-';
                    const periodTxt = periodType
                        ? `${periodCount}${periodType === 'M' ? '개월' : ''}${periodType === 'D' ? '일' : ''}`
                        : '-';

                    return {
                        ticketType,
                        type: TICKET_TYPES[ticketType],
                        cntTxt,
                        periodTxt,
                        ...rest,
                    };
                })
                .sort((a, b) => {
                    const a_order = types.indexOf(a.ticketType);
                    const b_order = types.indexOf(b.ticketType);

                    if (a_order < b_order) return -1;
                    if (a_order > b_order) return 1;

                    if (a.name < b.name) return -1;
                    if (a.name > b.name) return 1;

                    return 0;
                });
        },

        onClickSearchProd() {
            // 이용권 검색버튼 클릭
            this.arrangeProdInfo(this.centerProdInfo);
        },

        onResetSearch() {
            this.searchProdKeyword = '';
            this.arrangeProdInfo(this.centerProdInfo);
        },

        // 이용권 유형 코드 변환
        getTicketTypeString(ticketType) {
            let str = '';
            switch (ticketType) {
                case 'P': // 개인
                    str = '[개인]';
                    break;
                case 'O': // OT
                    str = '[OT]';
                    break;
                case 'D': // 듀엣
                    str = '[듀엣]';
                    break;
                case 'G': // 그룹
                    str = '[그룹]';
                    break;
                case 'C': // 쿠폰
                    str = '[쿠폰]';
                    break;
                case 'T': // 회원권
                    str = '[회원권]';
                    break;
                case 'S': // 운동복
                    str = '[운동복]';
                    break;
            }
            return str;
        },

        // 수업 횟수 유형 변환
        getLessonCntString(lessonCountType, lessonCount) {
            let str = '';
            switch (lessonCountType) {
                case 'T': // 총횟수
                    str = `${lessonCount}회`;
                    break;
                case 'W': // 주당횟수
                    str = `주 ${lessonCount}회`;
                    break;
                case 'U': // 무제한
                    str = '';
                    break;
            }
            return str;
        },

        // 수업 유형 변환
        getLessonCntType(lessonCountType) {
            let str = '';
            switch (lessonCountType) {
                case 'T':
                    str = '총 ';
                    break;
                case 'W':
                    str = '주 ';
                    break;
                default:
                    str = '무제한';
                    break;
            }
            return str;
        },

        // 센터 상품 목록 조회 API
        sendGetCenterProdList() {
            // 스웨거 검색: 티켓/패키지 상품 목록 조회
            return api.get(`/admin/api/center/${this.centerId}/product/ticket/all`);
        },

        // 결제정보추가 버튼 클릭시
        onClickAddPayment() {
            this.addBills();
        },

        // 결제정보 추가
        addBills(bill) {
            let money = this.totalBuyPrice.replace(/,/g, '');
            this.editField.bills.forEach((element) => {
                money = parseInt(money) - (element.billPrice || element.npReqPrice);
            });
            if (bill === undefined) {
                bill = {
                    billSeq: this.nextBillSeq(),
                    billPrice: money,
                    npReqPrice: 0,
                    payType: 'C',
                    payCardType: '',
                    payBankType: '',
                    billDate: this.today,
                    receiptType: 'N',
                    receiptNo: '',
                    spendMileage: 0,
                    isShowBtnDeletePayment: true,
                };
            }
            this.editField.bills.push(bill);
        },

        nextBillSeq() {
            let seq = 0;

            this.editField.bills.forEach((bill) => {
              if (bill.billSeq >= seq) seq = bill.billSeq + 1;
            });

            return seq;
        },

        // payment-info 변경 감지 이벤트
        onChangePaymentFields(params) {
            const { data, index } = params;
            this.$set(this.editField.bills, index, { ...data });
        },

        // payment-info 삭제 감지 이벤트
        onClickDeletePaymentFields(index) {
            this.$delete(this.editField.bills, index);
        },

        // 회원명 검색 버튼 클릭시
        onClickSearchCustomer() {
            this.userPop = true;
            this.$nextTick(function () {
                this.$refs.refCustomerName.focus();
            });
        },

        // 회원명으로 회원 검색
        async onSearchCustomer() {
            try {
                const { data } = await this.sendGetCustomer();
                this.setPageParams(data);
                this.searchCustomerList = data.items;
            } catch (error) {
                alert('회원 검색 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터 회원 페이징 목록 조회
        sendGetCustomer() {
            return api.get(`/admin/api/center/${this.centerId}/customer`, {
                params: {
                    ...this.pagingInfo,
                    searchStr: this.searchCustomerStr,
                },
            });
        },

        // 회원 검색 팝업 취소 버튼 클릭시
        onClickCancleSearchPop() {
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 회원 검색 팝업 선택 버튼 클릭시
        async onClickPickCustomer() {
            if (this.pickedCustomerId === '') {
                alert('회원을 선택하세요.');
                return;
            }
            // 현재 페이지의 customerId를 넣어줌
            let isTransmission = false;
            if (this.contractId && !this.returnYn) {
                isTransmission = true;
                this.transmissionParameter.toCenterCustomerId = this.pickedCustomerId;
            } else {
                this.customerId = this.pickedCustomerId;
            }
            await this.fetchCustomerDetail(this.pickedCustomerId, isTransmission); // 선택한 회원 id로 customer 상세 정보 가져옴
            // }
            // 회원 검색 관련 변수 초기화
            this.userPop = false;
            this.searchCustomerStr = '';
            this.searchCustomerList = [];
        },

        // 페이징 파라미터 저장
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },

        // 센터 회원 검색 페이지 변경 Handler
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchCustomer();
        },

        // select-form 이용권 선택시 이벤트
        async handleProductTypeSelect(val) {
            this.selectedProdType = val;
            this.arrangeProdInfo(this.centerProdInfo);
            this.selectedProd = '';
        },

        // select-form 이용권 선택시 이벤트
        async onClickProduct(val) {
            if (!val || !!this.contractId) return;

            this.selectedProd = val;
            await this.fetchProduct(val.centerProductId);
        },

        // product id로 센터상품 조회
        async fetchProduct(productId) {
            try {
                if (productId === '') {
                    return;
                }
                this.productIsLoading = true;
                // 추가된 이용권, 패키지 초기화
                this.addedProdListInfo = {};
                this.addedProdList = [];
                this.periodInfoList = [];

                const { data } = await this.sendGetProduct(productId);
                this.addedProdListInfo = data;
                if (data.productType === 'P') {
                    // 추가한 상품이 패키지일 경우
                    this.addedProductType = 'P';
                    data.packageCenterProducts.forEach((p) => {
                        const temp = {
                            centerProductId: p.centerProductId,
                            centerProductVersion: p.centerProductVersion,
                            productOrgPrice: this.getNumberFormat(p.recvPrice),
                            productBuyPrice: this.getNumberFormat(p.sellPrice, this.addedProdListInfo.vatYn),
                            saleStaffId: null,
                            saleStaffContractType: 'N',
                            lessonStaffId: null,
                            lessStaffContractType: 'N',
                            expireStartDt: moment().format('YYYY-MM-DD'),
                            expireEndDt:
                                p.periodType === 'M'
                                    ? moment().add(p.periodCount, 'month').subtract(1, 'days').format('YYYY-MM-DD')
                                    : moment().add(p.periodCount, 'day').format('YYYY-MM-DD'),
                            lessonCount: p.lessonCount,
                            lessonCountType: p.lessonCountType,
                            turnBillPrice: '',
                            lessonResverStaffYn: false,
                        };
                        this.addedProdList.push(temp);
                    });
                } else if (data.productType === 'T') {
                    this.addedProductType = 'T';
                    const temp = {
                        centerProductId: data.centerProductId,
                        centerProductVersion: data.centerProductVersion,
                        // contractProductSeq: this.addedProdListInfo.length,
                        productOrgPrice: this.getNumberFormat(data.recvPrice),
                        productBuyPrice: this.getNumberFormat(data.sellPrice, this.addedProdListInfo.vatYn),
                        saleStaffId: null,
                        saleStaffContractType: 'N',
                        lessonStaffId: null,
                        lessStaffContractType: 'N',
                        expireStartDt: moment().format('YYYY-MM-DD'),
                        expireEndDt:
                            data.periodType === 'M'
                                ? moment().add(data.periodCount, 'month').subtract(1, 'days').format('YYYY-MM-DD')
                                : moment().add(data.periodCount, 'day').subtract(1, 'days').format('YYYY-MM-DD'),
                        lessonCount: data.lessonCount,
                        lessonCountType: data.lessonCountType,
                        turnBillPrice: '',
                        lessonResverStaffYn: false,
                    };
                    this.addedProdList.push(temp);
                }
                this.productIsLoading = false;
            } catch (error) {
                alert('센터 상품 조회 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터상품 조회 API 호출
        sendGetProduct(productId) {
            return api.get(`/admin/api/center/${this.centerId}/product/${productId}`);
        },

        // 금액에 , 넣기
        getNumberFormat(num, vatYn) {
            if (typeof num !== 'number' || num === undefined || num === '') {
                return num;
            }
            if (vatYn) {
                num = parseInt(parseInt(num) * 1.1);
                return num.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return num.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ',');
        },

        // 금액에 , 빼기
        getPureNumber(str) {
            if (typeof str !== 'string' || str === undefined || str === '') {
                return str;
            }
            return parseInt(str.toString().replace(/[^\d]+/g, ''));
        },

        // 숫자 이외 입력 방지
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (!(charCode >= 48 && charCode <= 57)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 취소 버튼 클릭시
        onClickCancleBtn() {
            if (this.contractId) {
                // 수정일 경우 결제내역 페이지로 이동
                this.$router.push({
                    path: `/madmin/member/payment/${this.centerId}`,
                    query: { customerId: this.customerId },
                });
            } else if (!this.contractId) {
                // 신규 등록일 경우 회원 목록 페이지로 이동
                this.$router.push('/madmin/member/list');
            }
        },

        // 실제구매가 수정시
        onKeyupProdBuyPrice(e, index) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            this.addedProdList[index].productBuyPrice = this.getNumberFormat(num);
            /* 고객 요청에 의해서 해당 기능 삭제
      if(this.getPureNumber(this.addedProdList[index].productOrgPrice) < this.getPureNumber(e.target.value)) { // 정상가 보다 크면 alert 띄움
          alert('실제구매가가 정상가보다 큽니다.');
      }
      */
        },

        // 1회 당 정산금액 수정시
        onKeyupTurnBillPrice(e, index) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            this.addedProdList[index].turnBillPrice = this.getNumberFormat(num);
        },

        // 이용권 환불 팝업 - 사용금액 수정시
        onKeyupReturnUsePrice(e, index) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            const initUsePrice = this.getPureNumber(this.addedProdList[index].returnUsePrice);
            const productPrice = this.getPureNumber(this.addedProdList[index].productBuyPrice);
            if (productPrice <= num) {
                e.target.value = this.getNumberFormat(productPrice);
                this.addedProdList[index].returnUsePrice = this.getNumberFormat(productPrice);
                this.addedProdList[index].returnPrice = this.getNumberFormat(
                    this.getPureNumber(this.addedProdList[index].productBuyPrice) -
                        this.getPureNumber(this.addedProdList[index].returnUsePrice)
                );
            } else {
                this.addedProdList[index].returnUsePrice = this.getNumberFormat(num);
                this.addedProdList[index].returnPrice = this.getNumberFormat(
                    this.getPureNumber(this.addedProdList[index].productBuyPrice) -
                        this.getPureNumber(this.addedProdList[index].returnUsePrice)
                );
            }
        },

        // 이용권 환불 팝업 - 환불금액 수정시
        onKeyupReturnPrice(e, index) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            const productPrice = this.getPureNumber(this.addedProdList[index].productBuyPrice);
            if (productPrice <= num) {
                e.target.value = this.getNumberFormat(productPrice);
                this.addedProdList[index].returnPrice = this.getNumberFormat(productPrice);
                this.addedProdList[index].returnUsePrice = this.getNumberFormat(
                    this.getPureNumber(this.addedProdList[index].productBuyPrice) -
                        this.getPureNumber(this.addedProdList[index].returnPrice)
                );
            } else {
                this.addedProdList[index].returnPrice = this.getNumberFormat(num);
                this.addedProdList[index].returnUsePrice = this.getNumberFormat(
                    this.getPureNumber(this.addedProdList[index].productBuyPrice) -
                        this.getPureNumber(this.addedProdList[index].returnPrice)
                );
            }
        },

        // 이용권 환불 팝업 - 마일리지 차감 금액 수정시
        onKeyupReturnMileagePrice(e, change = false) {
            if (e.target.value === '') {
                return;
            }
            const num = this.getPureNumber(e.target.value);
            if (num > this.customerInfo.mileage) {
                change
                    ? (this.addedProdList[0].returnMileagePrice = this.getNumberFormat(this.customerInfo.mileage))
                    : (this.returnMileagePrice = this.getNumberFormat(this.customerInfo.mileage));
            } else {
                change
                    ? (this.addedProdList[0].returnMileagePrice = this.getNumberFormat(num))
                    : (this.returnMileagePrice = this.getNumberFormat(num));
            }
        },

        // 담당강사 아이디로 강사이름 찾기
        searchByLessStaffId(lessStaffId) {
            let resultStr = '';
            if (lessStaffId === '' || !lessStaffId || this.centerStaffValueList.length === 0) {
                return '선택안함';
            }

            this.centerStaffValueList.forEach((s, index) => {
                if (s === lessStaffId) {
                    resultStr = this.centerStaffList[index];
                }
            });
            return resultStr;
        },

        // 매출직원 아이디로 매출직원이름 찾기
        searchBySaleStaffId(saleStaffId) {
            let resultStr = '';
            if (saleStaffId === '' || !saleStaffId || this.centerStaffValueList.length === 0) {
                return '선택안함';
            }

            this.centerStaffValueList.forEach((s, index) => {
                if (s === saleStaffId) {
                    resultStr = this.centerStaffList[index];
                }
            });
            return resultStr;
        },

        // 직원 아이디로직원명 찾기
        searchByStaffId(staffId) {
            let resultStr = '';
            if (staffId === '' || !staffId || this.centerStaffValueList.length === 0) {
                return resultStr;
            }

            this.centerStaffValueList.forEach((s, index) => {
                if (s === staffId) {
                    resultStr = this.centerStaffList[index];
                }
            });
            return resultStr;
        },

        // 환불 등록 버튼 클릭시
        async onClickRegistReturn() {
            try {
                const validate = this.validateReturnValues();
                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                this.returnIsLoading = true;
                await this.sendPutRegistReturn();
                alert('환불이 등록 되었습니다.');
                this.returnIsLoading = false;
                this.refundPop = false;
                await this.init();
            } catch (error) {
                this.returnIsLoading = false;
                alert('환불 등록 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원계약 상품 환불 요청 API 호출
        sendPutRegistReturn() {
            const params = this.getRegistReturnParams();
            const contractId = this.addedProdListInfo.centerContractId;
            const productId =
                this.prodIsT === true
                    ? this.addedProdList[0].centerProductId
                    : this.addedProdListInfo.centerContractProducts[0].centerProductId;
            // 스웨거 검색: 센터회원계약 상품 환불 요청
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${contractId}/product/${productId}/request-retrun`,
                {
                    ...params,
                }
            );
        },

        // 환불 요청하기 위한 파라미터 가공
        getRegistReturnParams() {
            const {
                returnStaffId,
                returnExpireEndDt,
                returnPayType,
                returnPayBank,
                returnPayOwn,
                returnPayAccount,
                returnMileagePrice,
                returnMemo,
                returnApplyAt,
            } = this;
            const params = {
                returnStaffId,
                returnApplyAt: returnApplyAt === '' ? this.today : returnApplyAt,
                returnExpireEndDt: this.addedProdList[0].returnExpireEndDt,
                returnPrice: this.getPureNumber(this.totalReturnPrice),
                returnPayType,
                returnPayBank,
                returnPayOwn,
                returnPayAccount,
                returnMileagePrice: returnMileagePrice !== '' ? this.getPureNumber(returnMileagePrice) : '',
                returnMemo,
            };
            if (returnMileagePrice === '') {
                delete params.returnMileagePrice;
            }
            if (returnPayAccount === '') {
                delete params.returnPayAccount;
            }
            if (returnPayOwn === '') {
                delete params.returnPayOwn;
            }
            if (returnPayBank === '') {
                delete params.returnPayBank;
            }
            if (returnMemo === '') {
                delete params.returnMemo;
            }
            return params;
        },

        // 파라미터 validate
        validateReturnValues() {
            // 필수값 체크
            let result = false;
            const {
                returnStaffId,
                returnPayType,
                addedProdList,
                returnPayAccount,
                returnPayBank,
                returnPayOwn,
                returnMileagePrice,
            } = this;
            let msg = '';

            // 환불직원
            if (returnStaffId === '' || returnStaffId === undefined) {
                msg = '환불직원을 선택하세요.';
                return { result, msg };
            }

            // 환불수단
            if (returnPayType === '') {
                msg = '환불수단을 선택하세요.';
                return { result, msg };
            }

            if (returnPayType === 'B') {
                // 계좌이체일 경우
                if (returnPayBank.trim() === '') {
                    msg = '은행명을 입력하세요.';
                    return { result, msg };
                }
                if (returnPayOwn.trim() === '') {
                    msg = '예금주를 입력하세요.';
                    return { result, msg };
                }
                if (returnPayAccount.trim() === '') {
                    msg = '계좌번호를 입력하세요.';
                    return { result, msg };
                }
                if (returnPayAccount !== '' && !validateNumber(returnPayAccount)) {
                    msg = '계좌번호를 다시 입력하세요.';
                    return { result, msg };
                }
            }

            // 마일리지 차감
            if (returnMileagePrice !== '') {
                if (!validateNumber(this.getPureNumber(returnMileagePrice))) {
                    msg = '마일리지 차감액을 다시 입력하세요.';
                    return { result, msg };
                }
            }

            // 추가된 이용권들의 유효기간, 실제구매가, 매출직원, 담당강사 체크
            addedProdList.some((p, index) => {
                if (p.returnUsePrice === '') {
                    msg = `${index + 1}번째 이용권의 사용금액을 입력하세요.`;
                    return true;
                } else if (!validateNumber(this.getPureNumber(p.returnUsePrice))) {
                    msg = `${index + 1}번째 이용권의 실제구매가를 다시 입력하세요.`;
                    return true;
                }

                if (p.returnPrice === '') {
                    msg = `${index + 1}번째 이용권의 환불금액을 입력하세요.`;
                    return true;
                } else if (!validateNumber(this.getPureNumber(p.returnPrice))) {
                    msg = `${index + 1}번째 이용권의 환불금액을 다시 입력하세요.`;
                    return true;
                }
            });

            // 환불금액 체크
            if (this.getPureNumber(this.totalBuyPrice) < this.getPureNumber(this.totalReturnPrice)) {
                // 환불금액이 결제금액보다 큰지 체크
                msg = '환불금액이 결제금액보다 큽니다. 환불금액을 다시 입력하세요.';
            }

            if (msg !== '') {
                result = false;
            } else {
                result = true;
            }

            return { result, msg };
        },

        // 이용권 기간연장 버튼 클릭시
        async onClickExtendDetail(selectedExtendDetail, layerTabNumber) {
            this.periodPopProps = {
                customerName: this.editField.name,
                layerTabNumber,
                selectedExtendDetail,
                expPlusStaffList: this.centerStaffList,
                expPlusStaffValueList: this.centerStaffValueList,
                centerId: this.centerId,
                centerContractId: this.contractId,
                centerStaffId: this.centerStaffId,
            };
            this.periodPop = true;
            /*
      try {
          const selectEndDt = moment(this.addedProdList[index].expireEndDt).format('YYYY-MM-DD');
          if(!confirm(`${selectEndDt} 으로 유효기간을 연장 하시겠습니까?`)){
              return false;
          }
          // 연장일수 체크
          let plusDayCount = this.getDaysDiff(this.addedProdList[index].expireEndDt - this.addedProdList[index].expirePlusEndDt);
          if(plusDayCount === 0){
              alert('현재 종료 유효기간과 연장일자가 같습니다.');
              return false;
          }else if(plusDayCount < 0){
              alert('현재 종료 유효기간보다 이후의 날짜를 선택하세요.');
              return false;
          }

          await this.sendPutExtendContract(centerId, centerContractId, index, plusDayCount);
          await this.init();
          alert('이용권이 기간연장 되었습니다.');
      } catch (error) {
          console.log(error);
      }
      */
        },

        // 이용권 기간연장 API 호출
        sendPutExtendContract(centerId, centerContractId, index, plusDayCount) {
            const params = this.getExtendParams(index, plusDayCount);
            return api.put(`/admin/api/center/${centerId}/contract/extend/${centerContractId}`, {
                ...params,
            });
        },

        // 이용권 기간연장 파라미터 가공
        getExtendParams(index, plusDayCount) {
            const params = {
                expirePlusType: 'N', // 연장유형 코드 (미사용 : -, 연기 : N, 홀딩 : H)
                expirePlusStartDt: this.addedProdList[index].expireStartDt,
                expirePlusEndDt: this.addedProdList[index].expireEndDt,
                expirePlusDay: plusDayCount,
                expirePlusStaffId: parseInt(this.addedProdListInfo.regStaffId),
                expirePlusMemo: '',
            };
            return params;
        },

        // 연장일수 계산
        getDaysDiff(endDt, plusEndDt) {
            // endDt : 연장하고자 하는 유효기간 종료일, plusEndDt : 기존 유효기간 종료일
            const ed = moment(endDt, 'YYYY-MM-DD');
            const ped = moment(plusEndDt).startOf('day');
            const expirePlusDay = moment.duration(ed.diff(ped)).asDays();
            return expirePlusDay;
        },

        // 환불수단 변환
        convertPayWay(returnPayType, returnPayBank, returnPayAccount, returnPayOwn) {
            const result = ['', '', '', ''];
            if (returnPayType === 'L') {
                result[0] = '현금';
            } else if (returnPayType === 'B') {
                result[0] = '계좌이체';
                result[1] = returnPayBank;
                result[2] = returnPayAccount;
                result[3] = returnPayOwn;
                return `${result[0]} (${result[1]} ${result[2]} ${result[3]})`;
            } else if (returnPayType === 'C') {
                result[0] = '카드취소';
            } else {
                result[0] = '';
            }

            return result[0];
        },

        // 센터회원계약 삭제 버튼 클릭시
        async onClickDeleteBtn() {
            try {
                if (
                    !confirm(
                        '정말 삭제하시겠습니까? 이용권 삭제 시 결제정보, 스케줄예약내역, 급여정산내역 등등 이용권과 관련돈 모든 정보가 삭제되면 복구 불가합니다.'
                    )
                ) {
                    return false;
                }
                this.isLoading = true;
                await this.sendDeleteContract();
                alert('이용권을 삭제했습니다.');
                this.isLoading = false;
                this.$router.push({
                    path: `/madmin/member/payment/${this.centerId}`,
                    query: { customerId: this.customerId },
                });
            } catch (error) {
                alert('이용권을 삭제하는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원계약 삭제 API 호출
        sendDeleteContract() {
            return api.delete(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${this.addedProdListInfo.centerContractId}`
            );
        },

        // 환불 삭제 버튼 클릭시
        async onClickCancleReturn() {
            try {
                if (!confirm('이용권 환불을 취소하시겠습니까?')) {
                    return false;
                }
                await this.sendPutCancleReturn();
                alert('환불이 취소 되었습니다.');
                await this.init();
            } catch (error) {
                alert('환불 삭제 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 환불 취소 요청 API 호출
        sendPutCancleReturn() {
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${this.customerId}/contract/${this.addedProdListInfo.centerContractProducts[0].centerContractId}/product/${this.addedProdListInfo.centerContractProducts[0].centerProductId}/cancel-retrun`
            );
        },

        // 결제정보 삭제 버튼 클릭시 (b.centerCustomerId, b.centerContractId, b.billSeq, index)
        async onClickDeleteBills(customerId, contractId, billSeq, index) {
            try {
                await this.sendDeleteContractBill(customerId, contractId, billSeq, index);
                alert('결제정보가 삭제 되었습니다.');
                await this.init();
            } catch (error) {
                this.isLoading = false;
                alert('결제정보 삭제 중 오류가 발생했습니다.');
            }
        },

        // 센터회원계약 결제내역 삭제 API 호출
        sendDeleteContractBill(customerId, contractId, billSeq, index) {
            return api.delete(
                `/admin/api/center/${this.centerId}/customer/${customerId}/contract/${contractId}/bill/${billSeq}`
            );
        },

        // 결제정보 수정 버튼 클릭시 (b.centerCustomerId, b.centerContractId, b.billSeq, index)
        onClickModifyBills(customerId, contractId, billSeq, index) {
            this.editField.bills[index].mode = 'modify'; // 읽기모드 -> 수정모드로 변경
            this.$forceUpdate();
        },

        // 결제정보 저장 버튼 클릭시
        async onClickSaveBills(customerId, contractId, billSeq, index) {
            try {
                await this.sendPutContractBill(customerId, contractId, billSeq, index);
                alert('결제정보가 수정 되었습니다.');
                await this.init();
            } catch (error) {
                this.isLoading = false;
                alert('결제정보 수정 중 오류가 발생했습니다.');
            }
        },

        // 센터회원계약 결제내역 수정 API 호출
        sendPutContractBill(customerId, contractId, billSeq, index) {
            const params = this.getParamsModifyContractBill(customerId, contractId, billSeq, index);
            return api.put(
                `/admin/api/center/${this.centerId}/customer/${customerId}/contract/${contractId}/bill/${billSeq}`,
                {
                    ...params,
                }
            );
        },

        // 센터회원계약 결제내역 수정 파라미터 가공
        getParamsModifyContractBill(customerId, contractId, billSeq, index) {
            const bill = this.editField.bills[index];

            const params = {
                debtYn: false,
                billSeq,
                buyDate: bill.billDate,
                billPrice:
                    bill.payType === 'M' ? this.getPureNumber(bill.spendMileage) : this.getPureNumber(bill.billPrice),
                npReqPrice: bill.payType === 'U' ? this.getPureNumber(bill.npReqPrice) : 0,
                payType: bill.payType,
                payCardType: bill.payCardType,
                payBankType: bill.payBankType,
                mileage: this.getPureNumber(bill.acmltMileagePrice),
                receiptType: bill.receiptType,
                receiptNo: this.getPureReceiptNo(bill.receiptNo),
                totalDebtPrice: this.getPureNumber(this.totalDebtPrice),
            };

            if (bill.payType !== 'L' && bill.payType !== 'B') {
                delete params.receiptType;
                delete params.receiptNo;
            }
            if (bill.payType !== 'C') {
                // 카드가 아닐때 카드 파라미터 삭제
                delete params.payCardType;
            }
            if (bill.payType !== 'B') {
                // 계좌이체가 아닐때 은행 파라미터 삭제
                delete params.payBankType;
            }

            return params;
        },

        // 영수증 번호에 대시(-) 제거
        getPureReceiptNo(str) {
            if (typeof str !== 'string' || str === undefined || str === '') {
                return str;
            }
            return str.toString().replace(/[^0-9]/g, '');
        },

        // 이용권의 유효기간의 시작일을 변경할 때, 종료일도 유효기간에 따라 자동적으로 변경해주는 함수
        changeExpireDate(expireStartDt, centerProductId) {
            const { periodString, periodCount } = this.getPeriodInfo(centerProductId);
            // const expireEndDt = moment(expireStartDt).add(periodCount, periodString).format('YYYY-MM-DD');

            const expireEndDtMoment = moment(expireStartDt).add(periodCount, periodString);
            expireEndDtMoment.subtract(1, 'days');
            /*
      if (periodString === 'month') {
        expireEndDtMoment.subtract(1, 'days');
      }
      */
            const expireEndDt = expireEndDtMoment.format('YYYY-MM-DD');

            this.addedProdList.forEach((p) => {
                if (p.centerProductId === centerProductId) {
                    p.expireStartDt = expireStartDt;
                    p.expireEndDt = expireEndDt;
                }
            });
        },

        // centerProductId를 이용해서 periodString과 periodCount를 구하는 함수
        getPeriodInfo(centerProductId) {
            let periodType;
            let periodCount;

            // 이용권과 패키지에 따라서 periodType과 periodCount를 구하는 방법이 구분됨.
            if (this.addedProductType === 'T') {
                periodType = this.addedProdListInfo.periodType;
                periodCount = this.addedProdListInfo.periodCount;
            } else if (this.addedProductType === 'P') {
                const product = this.addedProdListInfo.packageCenterProducts.find(
                    (p) => p.centerProductId === centerProductId
                );
                periodType = product.periodType;
                periodCount = product.periodCount;
            }

            const periodString = periodType === 'M' ? 'month' : 'day';

            return { periodString, periodCount };
        },

        // chainCenter를 이용해서 센터 이름을 구하는 함수
        getCenterName() {
            let index;

            for (let i = 0; i < this.chainCenterTypeValue.length; i++) {
                if (this.chainCenterTypeValue[i] === this.chainCenter) {
                    index = i;
                    break;
                }
            }

            return this.chainCenterType[index];
        },

        isInfinity(index, p) {
            if (this.prodIsT) {
                // 이용권인 경우
                if (this.addedProdListInfo.lessonCountType === 'U') {
                    return true;
                }

                return false;
            } else if (!this.contractId && this.prodIsP) {
                if (this.addedProdListInfo.packageCenterProducts[index].lessonCountType === 'U') {
                    return true;
                }

                return false;
            } else if (this.contractId && this.prodIsP) {
                if (p.centerProduct.lessonCountType === 'U') {
                    return true;
                }

                return false;
            }
        },

        // 기간을 연장하는 함수
        periodInit() {
            this.periodPop = false;
            this.fetchContractDetail(this.contractId);
            this.$router.push({
                path: `/madmin/member/payment/${this.centerId}`,
                query: { customerId: this.customerId },
            });
        },

        // 마일리지 설정 정보를 가져오기
        async getMileageInfo() {
            try {
                const { data } = await api.get(`/admin/api/centerMileage/${this.cId}`);
                this.mileageInfo = data;
            } catch (e) {
                console.error(e);
            }
        },
        moveHistory(type, prodName, custName) {
            // 히스토리 페이지로 연결
            this.$router.push({
                name: 'CourseCareHistory',
                params: {
                    name: custName,
                    title: prodName,
                    type,
                    custId: this.$route.query.customerId,
                    contractId: this.$route.query.contractId,
                },
            });
        },
        onPopupRefund() {
            this.refundPop = true;
            this.returnStaffId = Number(this.centerStaffId);
        },
        getDateFormatFilter(date) {
            return date.trim() ? moment(date).format('YYYY-MM-DD') : '';
        },
        checkAllowedCount(p, type) {
            if (type === 'W' || type === 'U') {
                this.countMessage = '';
                return;
            }
            if (parseInt(this.$route.query.allowedCount, 10) > p) {
                this.countMessage = '예약되어있는 횟수 보다 낮은 값을 넣을 수 없습니다.';
                return true;
            }
            this.countMessage = '';
            return false;
        },
    },
};
</script>

<style lang="scss">
.vm--container {
  z-index: 1001 !important;
}
</style>
